let wasm;

let cachedUint8ArrayMemory0 = null;

function getUint8ArrayMemory0() {
    if (cachedUint8ArrayMemory0 === null || cachedUint8ArrayMemory0.byteLength === 0) {
        cachedUint8ArrayMemory0 = new Uint8Array(wasm.memory.buffer);
    }
    return cachedUint8ArrayMemory0;
}

let cachedTextDecoder = new TextDecoder('utf-8', { ignoreBOM: true, fatal: true });

cachedTextDecoder.decode();

const MAX_SAFARI_DECODE_BYTES = 2146435072;
let numBytesDecoded = 0;
function decodeText(ptr, len) {
    numBytesDecoded += len;
    if (numBytesDecoded >= MAX_SAFARI_DECODE_BYTES) {
        cachedTextDecoder = new TextDecoder('utf-8', { ignoreBOM: true, fatal: true });
        cachedTextDecoder.decode();
        numBytesDecoded = len;
    }
    return cachedTextDecoder.decode(getUint8ArrayMemory0().subarray(ptr, ptr + len));
}

function getStringFromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return decodeText(ptr, len);
}

let WASM_VECTOR_LEN = 0;

const cachedTextEncoder = new TextEncoder();

if (!('encodeInto' in cachedTextEncoder)) {
    cachedTextEncoder.encodeInto = function (arg, view) {
        const buf = cachedTextEncoder.encode(arg);
        view.set(buf);
        return {
            read: arg.length,
            written: buf.length
        };
    }
}

function passStringToWasm0(arg, malloc, realloc) {

    if (realloc === undefined) {
        const buf = cachedTextEncoder.encode(arg);
        const ptr = malloc(buf.length, 1) >>> 0;
        getUint8ArrayMemory0().subarray(ptr, ptr + buf.length).set(buf);
        WASM_VECTOR_LEN = buf.length;
        return ptr;
    }

    let len = arg.length;
    let ptr = malloc(len, 1) >>> 0;

    const mem = getUint8ArrayMemory0();

    let offset = 0;

    for (; offset < len; offset++) {
        const code = arg.charCodeAt(offset);
        if (code > 0x7F) break;
        mem[ptr + offset] = code;
    }

    if (offset !== len) {
        if (offset !== 0) {
            arg = arg.slice(offset);
        }
        ptr = realloc(ptr, len, len = offset + arg.length * 3, 1) >>> 0;
        const view = getUint8ArrayMemory0().subarray(ptr + offset, ptr + len);
        const ret = cachedTextEncoder.encodeInto(arg, view);

        offset += ret.written;
        ptr = realloc(ptr, len, offset, 1) >>> 0;
    }

    WASM_VECTOR_LEN = offset;
    return ptr;
}

let cachedDataViewMemory0 = null;

function getDataViewMemory0() {
    if (cachedDataViewMemory0 === null || cachedDataViewMemory0.buffer.detached === true || (cachedDataViewMemory0.buffer.detached === undefined && cachedDataViewMemory0.buffer !== wasm.memory.buffer)) {
        cachedDataViewMemory0 = new DataView(wasm.memory.buffer);
    }
    return cachedDataViewMemory0;
}

function isLikeNone(x) {
    return x === undefined || x === null;
}

function debugString(val) {
    // primitive types
    const type = typeof val;
    if (type == 'number' || type == 'boolean' || val == null) {
        return  `${val}`;
    }
    if (type == 'string') {
        return `"${val}"`;
    }
    if (type == 'symbol') {
        const description = val.description;
        if (description == null) {
            return 'Symbol';
        } else {
            return `Symbol(${description})`;
        }
    }
    if (type == 'function') {
        const name = val.name;
        if (typeof name == 'string' && name.length > 0) {
            return `Function(${name})`;
        } else {
            return 'Function';
        }
    }
    // objects
    if (Array.isArray(val)) {
        const length = val.length;
        let debug = '[';
        if (length > 0) {
            debug += debugString(val[0]);
        }
        for(let i = 1; i < length; i++) {
            debug += ', ' + debugString(val[i]);
        }
        debug += ']';
        return debug;
    }
    // Test for built-in
    const builtInMatches = /\[object ([^\]]+)\]/.exec(toString.call(val));
    let className;
    if (builtInMatches && builtInMatches.length > 1) {
        className = builtInMatches[1];
    } else {
        // Failed to match the standard '[object ClassName]'
        return toString.call(val);
    }
    if (className == 'Object') {
        // we're a user defined class or Object
        // JSON.stringify avoids problems with cycles, and is generally much
        // easier than looping through ownProperties of `val`.
        try {
            return 'Object(' + JSON.stringify(val) + ')';
        } catch (_) {
            return 'Object';
        }
    }
    // errors
    if (val instanceof Error) {
        return `${val.name}: ${val.message}\n${val.stack}`;
    }
    // TODO we could test for more things here, like `Set`s and `Map`s.
    return className;
}

function addToExternrefTable0(obj) {
    const idx = wasm.__externref_table_alloc();
    wasm.__wbindgen_externrefs.set(idx, obj);
    return idx;
}

function handleError(f, args) {
    try {
        return f.apply(this, args);
    } catch (e) {
        const idx = addToExternrefTable0(e);
        wasm.__wbindgen_exn_store(idx);
    }
}

function getArrayU8FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getUint8ArrayMemory0().subarray(ptr / 1, ptr / 1 + len);
}

const CLOSURE_DTORS = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(state => state.dtor(state.a, state.b));

function makeMutClosure(arg0, arg1, dtor, f) {
    const state = { a: arg0, b: arg1, cnt: 1, dtor };
    const real = (...args) => {

        // First up with a closure we increment the internal reference
        // count. This ensures that the Rust closure environment won't
        // be deallocated while we're invoking it.
        state.cnt++;
        const a = state.a;
        state.a = 0;
        try {
            return f(a, state.b, ...args);
        } finally {
            state.a = a;
            real._wbg_cb_unref();
        }
    };
    real._wbg_cb_unref = () => {
        if (--state.cnt === 0) {
            state.dtor(state.a, state.b);
            state.a = 0;
            CLOSURE_DTORS.unregister(state);
        }
    };
    CLOSURE_DTORS.register(real, state, state);
    return real;
}
/**
 * Called automatically when WASM module is instantiated
 */
export function init() {
    wasm.init();
}

/**
 * Library version from Cargo.toml (e.g., "0.1.0")
 * @returns {string}
 */
export function version() {
    let deferred1_0;
    let deferred1_1;
    try {
        const ret = wasm.version();
        deferred1_0 = ret[0];
        deferred1_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
    }
}

/**
 * Git commit hash (short, 7 chars)
 * @returns {string}
 */
export function git_hash() {
    let deferred1_0;
    let deferred1_1;
    try {
        const ret = wasm.git_hash();
        deferred1_0 = ret[0];
        deferred1_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
    }
}

/**
 * Git describe (tag + commits, or just hash)
 * @returns {string}
 */
export function git_describe() {
    let deferred1_0;
    let deferred1_1;
    try {
        const ret = wasm.git_describe();
        deferred1_0 = ret[0];
        deferred1_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
    }
}

/**
 * Build date (YYYY-MM-DD)
 * @returns {string}
 */
export function build_date() {
    let deferred1_0;
    let deferred1_1;
    try {
        const ret = wasm.build_date();
        deferred1_0 = ret[0];
        deferred1_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
    }
}

/**
 * Full build info string (e.g., "0.1.0 (abc1234) - 2024-01-15")
 * @returns {string}
 */
export function build_info() {
    let deferred1_0;
    let deferred1_1;
    try {
        const ret = wasm.build_info();
        deferred1_0 = ret[0];
        deferred1_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
    }
}

/**
 * @returns {string}
 */
export function linked_device_field_kind() {
    let deferred1_0;
    let deferred1_1;
    try {
        const ret = wasm.linked_device_field_kind();
        deferred1_0 = ret[0];
        deferred1_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
    }
}

/**
 * @returns {string}
 */
export function linked_device_notification_kind() {
    let deferred1_0;
    let deferred1_1;
    try {
        const ret = wasm.linked_device_notification_kind();
        deferred1_0 = ret[0];
        deferred1_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
    }
}

/**
 * @returns {string}
 */
export function linked_device_key_sync_kind() {
    let deferred1_0;
    let deferred1_1;
    try {
        const ret = wasm.linked_device_key_sync_kind();
        deferred1_0 = ret[0];
        deferred1_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
    }
}

/**
 * @returns {string}
 */
export function linked_device_field_device_id() {
    let deferred1_0;
    let deferred1_1;
    try {
        const ret = wasm.linked_device_field_device_id();
        deferred1_0 = ret[0];
        deferred1_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
    }
}

/**
 * @returns {string}
 */
export function linked_device_field_temp_public_key() {
    let deferred1_0;
    let deferred1_1;
    try {
        const ret = wasm.linked_device_field_temp_public_key();
        deferred1_0 = ret[0];
        deferred1_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
    }
}

/**
 * @returns {string}
 */
export function linked_device_field_public_key() {
    let deferred1_0;
    let deferred1_1;
    try {
        const ret = wasm.linked_device_field_public_key();
        deferred1_0 = ret[0];
        deferred1_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
    }
}

/**
 * @returns {string}
 */
export function linked_device_field_secret_key() {
    let deferred1_0;
    let deferred1_1;
    try {
        const ret = wasm.linked_device_field_secret_key();
        deferred1_0 = ret[0];
        deferred1_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
    }
}

/**
 * @returns {string}
 */
export function linked_device_field_ml_kem_public_key() {
    let deferred1_0;
    let deferred1_1;
    try {
        const ret = wasm.linked_device_field_ml_kem_public_key();
        deferred1_0 = ret[0];
        deferred1_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
    }
}

/**
 * @returns {string}
 */
export function linked_device_field_ml_kem_secret_key() {
    let deferred1_0;
    let deferred1_1;
    try {
        const ret = wasm.linked_device_field_ml_kem_secret_key();
        deferred1_0 = ret[0];
        deferred1_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
    }
}

/**
 * @returns {string}
 */
export function linked_device_field_target_device_id() {
    let deferred1_0;
    let deferred1_1;
    try {
        const ret = wasm.linked_device_field_target_device_id();
        deferred1_0 = ret[0];
        deferred1_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
    }
}

/**
 * @returns {Uint8Array}
 */
export function secretbox_keygen() {
    const ret = wasm.secretbox_keygen();
    var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
    return v1;
}

/**
 * @returns {string}
 */
export function secretbox_keygen_base64() {
    let deferred1_0;
    let deferred1_1;
    try {
        const ret = wasm.secretbox_keygen_base64();
        deferred1_0 = ret[0];
        deferred1_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
    }
}

/**
 * @returns {Uint8Array}
 */
export function secretbox_nonce() {
    const ret = wasm.secretbox_nonce();
    var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
    return v1;
}

function passArray8ToWasm0(arg, malloc) {
    const ptr = malloc(arg.length * 1, 1) >>> 0;
    getUint8ArrayMemory0().set(arg, ptr / 1);
    WASM_VECTOR_LEN = arg.length;
    return ptr;
}

function takeFromExternrefTable0(idx) {
    const value = wasm.__wbindgen_externrefs.get(idx);
    wasm.__externref_table_dealloc(idx);
    return value;
}
/**
 * @param {Uint8Array} plaintext
 * @param {Uint8Array} nonce
 * @param {Uint8Array} key
 * @returns {Uint8Array}
 */
export function secretbox_seal(plaintext, nonce, key) {
    const ptr0 = passArray8ToWasm0(plaintext, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray8ToWasm0(nonce, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArray8ToWasm0(key, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ret = wasm.secretbox_seal(ptr0, len0, ptr1, len1, ptr2, len2);
    if (ret[3]) {
        throw takeFromExternrefTable0(ret[2]);
    }
    var v4 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
    return v4;
}

/**
 * @param {Uint8Array} ciphertext
 * @param {Uint8Array} nonce
 * @param {Uint8Array} key
 * @returns {Uint8Array}
 */
export function secretbox_open(ciphertext, nonce, key) {
    const ptr0 = passArray8ToWasm0(ciphertext, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray8ToWasm0(nonce, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArray8ToWasm0(key, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ret = wasm.secretbox_open(ptr0, len0, ptr1, len1, ptr2, len2);
    if (ret[3]) {
        throw takeFromExternrefTable0(ret[2]);
    }
    var v4 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
    return v4;
}

/**
 * @param {string} plaintext_base64
 * @param {string} nonce_base64
 * @param {string} key_base64
 * @returns {string}
 */
export function secretbox_seal_base64(plaintext_base64, nonce_base64, key_base64) {
    let deferred5_0;
    let deferred5_1;
    try {
        const ptr0 = passStringToWasm0(plaintext_base64, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(nonce_base64, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ptr2 = passStringToWasm0(key_base64, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len2 = WASM_VECTOR_LEN;
        const ret = wasm.secretbox_seal_base64(ptr0, len0, ptr1, len1, ptr2, len2);
        var ptr4 = ret[0];
        var len4 = ret[1];
        if (ret[3]) {
            ptr4 = 0; len4 = 0;
            throw takeFromExternrefTable0(ret[2]);
        }
        deferred5_0 = ptr4;
        deferred5_1 = len4;
        return getStringFromWasm0(ptr4, len4);
    } finally {
        wasm.__wbindgen_free(deferred5_0, deferred5_1, 1);
    }
}

/**
 * @param {string} ciphertext_base64
 * @param {string} nonce_base64
 * @param {string} key_base64
 * @returns {string}
 */
export function secretbox_open_base64(ciphertext_base64, nonce_base64, key_base64) {
    let deferred5_0;
    let deferred5_1;
    try {
        const ptr0 = passStringToWasm0(ciphertext_base64, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(nonce_base64, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ptr2 = passStringToWasm0(key_base64, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len2 = WASM_VECTOR_LEN;
        const ret = wasm.secretbox_open_base64(ptr0, len0, ptr1, len1, ptr2, len2);
        var ptr4 = ret[0];
        var len4 = ret[1];
        if (ret[3]) {
            ptr4 = 0; len4 = 0;
            throw takeFromExternrefTable0(ret[2]);
        }
        deferred5_0 = ptr4;
        deferred5_1 = len4;
        return getStringFromWasm0(ptr4, len4);
    } finally {
        wasm.__wbindgen_free(deferred5_0, deferred5_1, 1);
    }
}

/**
 * @returns {WasmKeyPair}
 */
export function box_keypair() {
    const ret = wasm.box_keypair();
    return WasmKeyPair.__wrap(ret);
}

/**
 * @param {Uint8Array} secret_key
 * @returns {WasmKeyPair}
 */
export function box_keypair_from_secret(secret_key) {
    const ptr0 = passArray8ToWasm0(secret_key, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.box_keypair_from_secret(ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return WasmKeyPair.__wrap(ret[0]);
}

/**
 * Build the canonical bytes to sign when writing an encrypted blob.
 *
 * Must be used rather than constructing the payload in JS: the server
 * derives the same bytes independently, so any difference produces a
 * signature it rejects.
 * @param {string} record_id
 * @param {bigint} version
 * @param {string} encrypted_data
 * @returns {Uint8Array}
 */
export function build_blob_write_payload(record_id, version, encrypted_data) {
    const ptr0 = passStringToWasm0(record_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(encrypted_data, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.build_blob_write_payload(ptr0, len0, version, ptr1, len1);
    var v3 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
    return v3;
}

/**
 * Generate an Ed25519 signing keypair for this device.
 *
 * The public half is published as `PublicKeyEntry.signingPublicKey`; the
 * secret half stays on the device. Authorizes writes to encrypted
 * thread/community blobs.
 * @returns {WasmKeyPair}
 */
export function signing_keypair() {
    const ret = wasm.signing_keypair();
    return WasmKeyPair.__wrap(ret);
}

/**
 * Sign a payload with this device's signing secret key.
 * @param {Uint8Array} message
 * @param {Uint8Array} secret_key
 * @returns {Uint8Array}
 */
export function sign(message, secret_key) {
    const ptr0 = passArray8ToWasm0(message, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray8ToWasm0(secret_key, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.sign(ptr0, len0, ptr1, len1);
    if (ret[3]) {
        throw takeFromExternrefTable0(ret[2]);
    }
    var v3 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
    return v3;
}

/**
 * Verify a signature against a signing public key.
 *
 * Returns false when a well-formed signature does not verify; throws only
 * on structurally invalid input. Both mean unauthorized.
 * @param {Uint8Array} message
 * @param {Uint8Array} signature
 * @param {Uint8Array} public_key
 * @returns {boolean}
 */
export function verify_signature(message, signature, public_key) {
    const ptr0 = passArray8ToWasm0(message, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray8ToWasm0(signature, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArray8ToWasm0(public_key, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ret = wasm.verify_signature(ptr0, len0, ptr1, len1, ptr2, len2);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return ret[0] !== 0;
}

/**
 * @returns {WasmMlKemKeyPair}
 */
export function ml_kem_768_keypair() {
    const ret = wasm.ml_kem_768_keypair();
    return WasmMlKemKeyPair.__wrap(ret);
}

/**
 * @returns {Uint8Array}
 */
export function box_nonce() {
    const ret = wasm.box_nonce();
    var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
    return v1;
}

/**
 * @param {Uint8Array} plaintext
 * @param {Uint8Array} nonce
 * @param {Uint8Array} their_public_key
 * @param {Uint8Array} my_secret_key
 * @returns {Uint8Array}
 */
export function box_seal(plaintext, nonce, their_public_key, my_secret_key) {
    const ptr0 = passArray8ToWasm0(plaintext, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray8ToWasm0(nonce, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArray8ToWasm0(their_public_key, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArray8ToWasm0(my_secret_key, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ret = wasm.box_seal(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3);
    if (ret[3]) {
        throw takeFromExternrefTable0(ret[2]);
    }
    var v5 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
    return v5;
}

/**
 * @param {Uint8Array} ciphertext
 * @param {Uint8Array} nonce
 * @param {Uint8Array} their_public_key
 * @param {Uint8Array} my_secret_key
 * @returns {Uint8Array}
 */
export function box_open(ciphertext, nonce, their_public_key, my_secret_key) {
    const ptr0 = passArray8ToWasm0(ciphertext, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray8ToWasm0(nonce, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArray8ToWasm0(their_public_key, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArray8ToWasm0(my_secret_key, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ret = wasm.box_open(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3);
    if (ret[3]) {
        throw takeFromExternrefTable0(ret[2]);
    }
    var v5 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
    return v5;
}

/**
 * Encrypt a DM (direct message) using asymmetric encryption
 * Takes plaintext, sender's secret key (base64), and receiver's public key (base64)
 * Returns encrypted content and nonce (both base64)
 * @param {string} plaintext
 * @param {string} sender_secret_key_base64
 * @param {string} receiver_public_key_base64
 * @returns {WasmEncryptedMessage}
 */
export function encrypt_dm_message(plaintext, sender_secret_key_base64, receiver_public_key_base64) {
    const ptr0 = passStringToWasm0(plaintext, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(sender_secret_key_base64, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passStringToWasm0(receiver_public_key_base64, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len2 = WASM_VECTOR_LEN;
    const ret = wasm.encrypt_dm_message(ptr0, len0, ptr1, len1, ptr2, len2);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return WasmEncryptedMessage.__wrap(ret[0]);
}

/**
 * Decrypt a DM (direct message) using asymmetric encryption
 * Takes encrypted content (base64), nonce (base64), sender's public key (base64),
 * and receiver's secret key (base64). Returns plaintext string.
 * @param {string} encrypted_content_base64
 * @param {string} nonce_base64
 * @param {string} sender_public_key_base64
 * @param {string} receiver_secret_key_base64
 * @returns {string}
 */
export function decrypt_dm_message(encrypted_content_base64, nonce_base64, sender_public_key_base64, receiver_secret_key_base64) {
    let deferred6_0;
    let deferred6_1;
    try {
        const ptr0 = passStringToWasm0(encrypted_content_base64, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(nonce_base64, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ptr2 = passStringToWasm0(sender_public_key_base64, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len2 = WASM_VECTOR_LEN;
        const ptr3 = passStringToWasm0(receiver_secret_key_base64, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len3 = WASM_VECTOR_LEN;
        const ret = wasm.decrypt_dm_message(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3);
        var ptr5 = ret[0];
        var len5 = ret[1];
        if (ret[3]) {
            ptr5 = 0; len5 = 0;
            throw takeFromExternrefTable0(ret[2]);
        }
        deferred6_0 = ptr5;
        deferred6_1 = len5;
        return getStringFromWasm0(ptr5, len5);
    } finally {
        wasm.__wbindgen_free(deferred6_0, deferred6_1, 1);
    }
}

/**
 * Encrypt a group message using symmetric encryption
 * Takes plaintext and group key (base64)
 * Returns encrypted content and nonce (both base64)
 * @param {string} plaintext
 * @param {string} group_key_base64
 * @returns {WasmEncryptedMessage}
 */
export function encrypt_group_message(plaintext, group_key_base64) {
    const ptr0 = passStringToWasm0(plaintext, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(group_key_base64, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.encrypt_group_message(ptr0, len0, ptr1, len1);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return WasmEncryptedMessage.__wrap(ret[0]);
}

/**
 * Decrypt a group message using symmetric encryption
 * Takes encrypted content (base64), nonce (base64), and group key (base64)
 * Returns plaintext string.
 * @param {string} encrypted_content_base64
 * @param {string} nonce_base64
 * @param {string} group_key_base64
 * @returns {string}
 */
export function decrypt_group_message(encrypted_content_base64, nonce_base64, group_key_base64) {
    let deferred5_0;
    let deferred5_1;
    try {
        const ptr0 = passStringToWasm0(encrypted_content_base64, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(nonce_base64, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ptr2 = passStringToWasm0(group_key_base64, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len2 = WASM_VECTOR_LEN;
        const ret = wasm.decrypt_group_message(ptr0, len0, ptr1, len1, ptr2, len2);
        var ptr4 = ret[0];
        var len4 = ret[1];
        if (ret[3]) {
            ptr4 = 0; len4 = 0;
            throw takeFromExternrefTable0(ret[2]);
        }
        deferred5_0 = ptr4;
        deferred5_1 = len4;
        return getStringFromWasm0(ptr4, len4);
    } finally {
        wasm.__wbindgen_free(deferred5_0, deferred5_1, 1);
    }
}

/**
 * Prepare a DM message for sending (high-level API)
 *
 * This is the recommended way to prepare messages - it handles:
 * - Content encryption (no JSON wrapping for TEXT/GIPHY, JSON for attachments)
 * - Thread ID generation
 * - Message ID generation
 *
 * content_type must be one of: "TEXT", "GIPHY", "FILE", "AUDIO", "VIDEO", "IMAGE"
 * @param {string} plaintext
 * @param {string} receiver_id
 * @param {string} receiver_public_key_base64
 * @param {string} my_user_id
 * @param {string} my_secret_key_base64
 * @param {string} content_type
 * @returns {WasmPreparedMessage}
 */
export function prepare_dm_message(plaintext, receiver_id, receiver_public_key_base64, my_user_id, my_secret_key_base64, content_type) {
    const ptr0 = passStringToWasm0(plaintext, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(receiver_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passStringToWasm0(receiver_public_key_base64, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passStringToWasm0(my_user_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len3 = WASM_VECTOR_LEN;
    const ptr4 = passStringToWasm0(my_secret_key_base64, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len4 = WASM_VECTOR_LEN;
    const ptr5 = passStringToWasm0(content_type, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len5 = WASM_VECTOR_LEN;
    const ret = wasm.prepare_dm_message(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4, ptr5, len5);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return WasmPreparedMessage.__wrap(ret[0]);
}

/**
 * Prepare a per-device DM envelope and select legacy or hybrid automatically.
 * @param {string} plaintext
 * @param {string} receiver_id
 * @param {string | null | undefined} receiver_device_id
 * @param {string} receiver_public_key_base64
 * @param {string | null | undefined} receiver_ml_kem_public_key_base64
 * @param {string} my_user_id
 * @param {string | null | undefined} my_device_id
 * @param {string} my_secret_key_base64
 * @param {string | null | undefined} my_ml_kem_secret_key_base64
 * @param {string} content_type
 * @returns {WasmPreparedMessage}
 */
export function prepare_dm_message_for_device(plaintext, receiver_id, receiver_device_id, receiver_public_key_base64, receiver_ml_kem_public_key_base64, my_user_id, my_device_id, my_secret_key_base64, my_ml_kem_secret_key_base64, content_type) {
    const ptr0 = passStringToWasm0(plaintext, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(receiver_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    var ptr2 = isLikeNone(receiver_device_id) ? 0 : passStringToWasm0(receiver_device_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len2 = WASM_VECTOR_LEN;
    const ptr3 = passStringToWasm0(receiver_public_key_base64, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len3 = WASM_VECTOR_LEN;
    var ptr4 = isLikeNone(receiver_ml_kem_public_key_base64) ? 0 : passStringToWasm0(receiver_ml_kem_public_key_base64, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len4 = WASM_VECTOR_LEN;
    const ptr5 = passStringToWasm0(my_user_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len5 = WASM_VECTOR_LEN;
    var ptr6 = isLikeNone(my_device_id) ? 0 : passStringToWasm0(my_device_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len6 = WASM_VECTOR_LEN;
    const ptr7 = passStringToWasm0(my_secret_key_base64, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len7 = WASM_VECTOR_LEN;
    var ptr8 = isLikeNone(my_ml_kem_secret_key_base64) ? 0 : passStringToWasm0(my_ml_kem_secret_key_base64, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len8 = WASM_VECTOR_LEN;
    const ptr9 = passStringToWasm0(content_type, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len9 = WASM_VECTOR_LEN;
    const ret = wasm.prepare_dm_message_for_device(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4, ptr5, len5, ptr6, len6, ptr7, len7, ptr8, len8, ptr9, len9);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return WasmPreparedMessage.__wrap(ret[0]);
}

/**
 * Prepare a group message for sending (high-level API)
 *
 * This is the recommended way to prepare group messages - it handles:
 * - Content encryption using symmetric group key
 * - Message ID generation
 * - Key version tracking for rotation support
 *
 * content_type must be one of: "TEXT", "GIPHY", "FILE", "AUDIO", "VIDEO", "IMAGE"
 * key_version is the version of the group key used for encryption
 * @param {string} plaintext
 * @param {string} group_id
 * @param {string} group_key_base64
 * @param {string} content_type
 * @param {number} key_version
 * @returns {WasmPreparedGroupMessage}
 */
export function prepare_group_message(plaintext, group_id, group_key_base64, content_type, key_version) {
    const ptr0 = passStringToWasm0(plaintext, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(group_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passStringToWasm0(group_key_base64, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passStringToWasm0(content_type, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len3 = WASM_VECTOR_LEN;
    const ret = wasm.prepare_group_message(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, key_version);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return WasmPreparedGroupMessage.__wrap(ret[0]);
}

/**
 * @param {string} sender_id
 * @param {string} receiver_id
 * @returns {string}
 */
export function create_thread_id(sender_id, receiver_id) {
    let deferred4_0;
    let deferred4_1;
    try {
        const ptr0 = passStringToWasm0(sender_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(receiver_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.create_thread_id(ptr0, len0, ptr1, len1);
        var ptr3 = ret[0];
        var len3 = ret[1];
        if (ret[3]) {
            ptr3 = 0; len3 = 0;
            throw takeFromExternrefTable0(ret[2]);
        }
        deferred4_0 = ptr3;
        deferred4_1 = len3;
        return getStringFromWasm0(ptr3, len3);
    } finally {
        wasm.__wbindgen_free(deferred4_0, deferred4_1, 1);
    }
}

/**
 * @param {string} user_id_a
 * @param {string} user_id_b
 * @returns {string}
 */
export function create_dm_conversation_id(user_id_a, user_id_b) {
    let deferred4_0;
    let deferred4_1;
    try {
        const ptr0 = passStringToWasm0(user_id_a, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(user_id_b, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.create_dm_conversation_id(ptr0, len0, ptr1, len1);
        var ptr3 = ret[0];
        var len3 = ret[1];
        if (ret[3]) {
            ptr3 = 0; len3 = 0;
            throw takeFromExternrefTable0(ret[2]);
        }
        deferred4_0 = ptr3;
        deferred4_1 = len3;
        return getStringFromWasm0(ptr3, len3);
    } finally {
        wasm.__wbindgen_free(deferred4_0, deferred4_1, 1);
    }
}

/**
 * @param {string} user_id
 * @returns {string}
 */
export function create_self_conversation_id(user_id) {
    let deferred3_0;
    let deferred3_1;
    try {
        const ptr0 = passStringToWasm0(user_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.create_self_conversation_id(ptr0, len0);
        var ptr2 = ret[0];
        var len2 = ret[1];
        if (ret[3]) {
            ptr2 = 0; len2 = 0;
            throw takeFromExternrefTable0(ret[2]);
        }
        deferred3_0 = ptr2;
        deferred3_1 = len2;
        return getStringFromWasm0(ptr2, len2);
    } finally {
        wasm.__wbindgen_free(deferred3_0, deferred3_1, 1);
    }
}

/**
 * @param {string} group_id
 * @returns {string}
 */
export function create_group_conversation_id(group_id) {
    let deferred3_0;
    let deferred3_1;
    try {
        const ptr0 = passStringToWasm0(group_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.create_group_conversation_id(ptr0, len0);
        var ptr2 = ret[0];
        var len2 = ret[1];
        if (ret[3]) {
            ptr2 = 0; len2 = 0;
            throw takeFromExternrefTable0(ret[2]);
        }
        deferred3_0 = ptr2;
        deferred3_1 = len2;
        return getStringFromWasm0(ptr2, len2);
    } finally {
        wasm.__wbindgen_free(deferred3_0, deferred3_1, 1);
    }
}

/**
 * @param {string} community_id
 * @param {string} community_channel_id
 * @returns {string}
 */
export function create_community_channel_conversation_id(community_id, community_channel_id) {
    let deferred4_0;
    let deferred4_1;
    try {
        const ptr0 = passStringToWasm0(community_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(community_channel_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.create_community_channel_conversation_id(ptr0, len0, ptr1, len1);
        var ptr3 = ret[0];
        var len3 = ret[1];
        if (ret[3]) {
            ptr3 = 0; len3 = 0;
            throw takeFromExternrefTable0(ret[2]);
        }
        deferred4_0 = ptr3;
        deferred4_1 = len3;
        return getStringFromWasm0(ptr3, len3);
    } finally {
        wasm.__wbindgen_free(deferred4_0, deferred4_1, 1);
    }
}

/**
 * @param {string} user_id_a
 * @param {string} user_id_b
 * @param {string} environment_id
 * @param {string} environment_channel_id
 * @param {string | null} [raw_access_mode]
 * @returns {string}
 */
export function create_dm_conversation_lane_json(user_id_a, user_id_b, environment_id, environment_channel_id, raw_access_mode) {
    let deferred7_0;
    let deferred7_1;
    try {
        const ptr0 = passStringToWasm0(user_id_a, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(user_id_b, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ptr2 = passStringToWasm0(environment_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len2 = WASM_VECTOR_LEN;
        const ptr3 = passStringToWasm0(environment_channel_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len3 = WASM_VECTOR_LEN;
        var ptr4 = isLikeNone(raw_access_mode) ? 0 : passStringToWasm0(raw_access_mode, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len4 = WASM_VECTOR_LEN;
        const ret = wasm.create_dm_conversation_lane_json(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4);
        var ptr6 = ret[0];
        var len6 = ret[1];
        if (ret[3]) {
            ptr6 = 0; len6 = 0;
            throw takeFromExternrefTable0(ret[2]);
        }
        deferred7_0 = ptr6;
        deferred7_1 = len6;
        return getStringFromWasm0(ptr6, len6);
    } finally {
        wasm.__wbindgen_free(deferred7_0, deferred7_1, 1);
    }
}

/**
 * @param {string} user_id
 * @param {string} environment_id
 * @param {string} environment_channel_id
 * @param {string | null} [raw_access_mode]
 * @returns {string}
 */
export function create_self_conversation_lane_json(user_id, environment_id, environment_channel_id, raw_access_mode) {
    let deferred6_0;
    let deferred6_1;
    try {
        const ptr0 = passStringToWasm0(user_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(environment_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ptr2 = passStringToWasm0(environment_channel_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len2 = WASM_VECTOR_LEN;
        var ptr3 = isLikeNone(raw_access_mode) ? 0 : passStringToWasm0(raw_access_mode, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len3 = WASM_VECTOR_LEN;
        const ret = wasm.create_self_conversation_lane_json(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3);
        var ptr5 = ret[0];
        var len5 = ret[1];
        if (ret[3]) {
            ptr5 = 0; len5 = 0;
            throw takeFromExternrefTable0(ret[2]);
        }
        deferred6_0 = ptr5;
        deferred6_1 = len5;
        return getStringFromWasm0(ptr5, len5);
    } finally {
        wasm.__wbindgen_free(deferred6_0, deferred6_1, 1);
    }
}

/**
 * @param {string} group_id
 * @param {string} environment_id
 * @param {string} environment_channel_id
 * @param {string | null} [raw_access_mode]
 * @returns {string}
 */
export function create_group_conversation_lane_json(group_id, environment_id, environment_channel_id, raw_access_mode) {
    let deferred6_0;
    let deferred6_1;
    try {
        const ptr0 = passStringToWasm0(group_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(environment_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ptr2 = passStringToWasm0(environment_channel_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len2 = WASM_VECTOR_LEN;
        var ptr3 = isLikeNone(raw_access_mode) ? 0 : passStringToWasm0(raw_access_mode, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len3 = WASM_VECTOR_LEN;
        const ret = wasm.create_group_conversation_lane_json(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3);
        var ptr5 = ret[0];
        var len5 = ret[1];
        if (ret[3]) {
            ptr5 = 0; len5 = 0;
            throw takeFromExternrefTable0(ret[2]);
        }
        deferred6_0 = ptr5;
        deferred6_1 = len5;
        return getStringFromWasm0(ptr5, len5);
    } finally {
        wasm.__wbindgen_free(deferred6_0, deferred6_1, 1);
    }
}

/**
 * @param {string} community_id
 * @param {string} community_channel_id
 * @param {string} environment_id
 * @param {string} environment_channel_id
 * @param {string | null} [raw_access_mode]
 * @returns {string}
 */
export function create_community_channel_conversation_lane_json(community_id, community_channel_id, environment_id, environment_channel_id, raw_access_mode) {
    let deferred7_0;
    let deferred7_1;
    try {
        const ptr0 = passStringToWasm0(community_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(community_channel_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ptr2 = passStringToWasm0(environment_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len2 = WASM_VECTOR_LEN;
        const ptr3 = passStringToWasm0(environment_channel_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len3 = WASM_VECTOR_LEN;
        var ptr4 = isLikeNone(raw_access_mode) ? 0 : passStringToWasm0(raw_access_mode, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len4 = WASM_VECTOR_LEN;
        const ret = wasm.create_community_channel_conversation_lane_json(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4);
        var ptr6 = ret[0];
        var len6 = ret[1];
        if (ret[3]) {
            ptr6 = 0; len6 = 0;
            throw takeFromExternrefTable0(ret[2]);
        }
        deferred7_0 = ptr6;
        deferred7_1 = len6;
        return getStringFromWasm0(ptr6, len6);
    } finally {
        wasm.__wbindgen_free(deferred7_0, deferred7_1, 1);
    }
}

/**
 * @param {string} lane_id
 * @returns {string | undefined}
 */
export function conversation_id_from_lane_id(lane_id) {
    const ptr0 = passStringToWasm0(lane_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.conversation_id_from_lane_id(ptr0, len0);
    let v2;
    if (ret[0] !== 0) {
        v2 = getStringFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
    }
    return v2;
}

/**
 * @param {string | null} [raw_kind]
 * @param {string | null} [conversation_id]
 * @param {string | null} [community_id]
 * @param {string | null} [current_user_id]
 * @param {string | null} [with_user_id]
 * @returns {string}
 */
export function conversation_projection_json(raw_kind, conversation_id, community_id, current_user_id, with_user_id) {
    let deferred6_0;
    let deferred6_1;
    try {
        var ptr0 = isLikeNone(raw_kind) ? 0 : passStringToWasm0(raw_kind, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len0 = WASM_VECTOR_LEN;
        var ptr1 = isLikeNone(conversation_id) ? 0 : passStringToWasm0(conversation_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len1 = WASM_VECTOR_LEN;
        var ptr2 = isLikeNone(community_id) ? 0 : passStringToWasm0(community_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len2 = WASM_VECTOR_LEN;
        var ptr3 = isLikeNone(current_user_id) ? 0 : passStringToWasm0(current_user_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len3 = WASM_VECTOR_LEN;
        var ptr4 = isLikeNone(with_user_id) ? 0 : passStringToWasm0(with_user_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len4 = WASM_VECTOR_LEN;
        const ret = wasm.conversation_projection_json(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4);
        deferred6_0 = ret[0];
        deferred6_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred6_0, deferred6_1, 1);
    }
}

/**
 * @param {string} lane_id
 * @param {string} conversation_kind
 * @returns {string | undefined}
 */
export function lane_key_scope(lane_id, conversation_kind) {
    const ptr0 = passStringToWasm0(lane_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(conversation_kind, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.lane_key_scope(ptr0, len0, ptr1, len1);
    let v3;
    if (ret[0] !== 0) {
        v3 = getStringFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
    }
    return v3;
}

/**
 * @param {string} sender_id
 * @param {string} receiver_id
 * @param {string} environment_id
 * @param {string} channel_id
 * @param {string | null} [raw_access_mode]
 * @returns {string}
 */
export function create_scoped_thread_id(sender_id, receiver_id, environment_id, channel_id, raw_access_mode) {
    let deferred7_0;
    let deferred7_1;
    try {
        const ptr0 = passStringToWasm0(sender_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(receiver_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ptr2 = passStringToWasm0(environment_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len2 = WASM_VECTOR_LEN;
        const ptr3 = passStringToWasm0(channel_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len3 = WASM_VECTOR_LEN;
        var ptr4 = isLikeNone(raw_access_mode) ? 0 : passStringToWasm0(raw_access_mode, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len4 = WASM_VECTOR_LEN;
        const ret = wasm.create_scoped_thread_id(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4);
        var ptr6 = ret[0];
        var len6 = ret[1];
        if (ret[3]) {
            ptr6 = 0; len6 = 0;
            throw takeFromExternrefTable0(ret[2]);
        }
        deferred7_0 = ptr6;
        deferred7_1 = len6;
        return getStringFromWasm0(ptr6, len6);
    } finally {
        wasm.__wbindgen_free(deferred7_0, deferred7_1, 1);
    }
}

/**
 * @param {string} user_id
 * @param {string} environment_id
 * @param {string} channel_id
 * @param {string | null} [raw_access_mode]
 * @returns {string}
 */
export function create_scoped_self_thread_key(user_id, environment_id, channel_id, raw_access_mode) {
    let deferred6_0;
    let deferred6_1;
    try {
        const ptr0 = passStringToWasm0(user_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(environment_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ptr2 = passStringToWasm0(channel_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len2 = WASM_VECTOR_LEN;
        var ptr3 = isLikeNone(raw_access_mode) ? 0 : passStringToWasm0(raw_access_mode, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len3 = WASM_VECTOR_LEN;
        const ret = wasm.create_scoped_self_thread_key(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3);
        var ptr5 = ret[0];
        var len5 = ret[1];
        if (ret[3]) {
            ptr5 = 0; len5 = 0;
            throw takeFromExternrefTable0(ret[2]);
        }
        deferred6_0 = ptr5;
        deferred6_1 = len5;
        return getStringFromWasm0(ptr5, len5);
    } finally {
        wasm.__wbindgen_free(deferred6_0, deferred6_1, 1);
    }
}

/**
 * @param {string} group_id
 * @param {string} environment_id
 * @param {string} channel_id
 * @param {string | null} [raw_access_mode]
 * @returns {string}
 */
export function create_scoped_group_thread_key(group_id, environment_id, channel_id, raw_access_mode) {
    let deferred6_0;
    let deferred6_1;
    try {
        const ptr0 = passStringToWasm0(group_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(environment_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ptr2 = passStringToWasm0(channel_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len2 = WASM_VECTOR_LEN;
        var ptr3 = isLikeNone(raw_access_mode) ? 0 : passStringToWasm0(raw_access_mode, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len3 = WASM_VECTOR_LEN;
        const ret = wasm.create_scoped_group_thread_key(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3);
        var ptr5 = ret[0];
        var len5 = ret[1];
        if (ret[3]) {
            ptr5 = 0; len5 = 0;
            throw takeFromExternrefTable0(ret[2]);
        }
        deferred6_0 = ptr5;
        deferred6_1 = len5;
        return getStringFromWasm0(ptr5, len5);
    } finally {
        wasm.__wbindgen_free(deferred6_0, deferred6_1, 1);
    }
}

/**
 * @param {string} thread_key
 * @returns {string}
 */
export function call_room_id(thread_key) {
    let deferred2_0;
    let deferred2_1;
    try {
        const ptr0 = passStringToWasm0(thread_key, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.call_room_id(ptr0, len0);
        deferred2_0 = ret[0];
        deferred2_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
    }
}

/**
 * @returns {string}
 */
export function generate_random_id() {
    let deferred1_0;
    let deferred1_1;
    try {
        const ret = wasm.generate_random_id();
        deferred1_0 = ret[0];
        deferred1_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
    }
}

/**
 * @param {number} length
 * @returns {string}
 */
export function generate_invite_code(length) {
    let deferred1_0;
    let deferred1_1;
    try {
        const ret = wasm.generate_invite_code(length);
        deferred1_0 = ret[0];
        deferred1_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
    }
}

/**
 * @returns {string}
 */
export function generate_uuid() {
    let deferred1_0;
    let deferred1_1;
    try {
        const ret = wasm.generate_uuid();
        deferred1_0 = ret[0];
        deferred1_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
    }
}

/**
 * @returns {string}
 */
export function generate_message_id() {
    let deferred1_0;
    let deferred1_1;
    try {
        const ret = wasm.generate_message_id();
        deferred1_0 = ret[0];
        deferred1_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
    }
}

/**
 * @param {string} id
 * @returns {boolean}
 */
export function is_thread_id(id) {
    const ptr0 = passStringToWasm0(id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.is_thread_id(ptr0, len0);
    return ret !== 0;
}

/**
 * @param {string} id
 * @returns {boolean}
 */
export function is_group_id(id) {
    const ptr0 = passStringToWasm0(id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.is_group_id(ptr0, len0);
    return ret !== 0;
}

/**
 * @param {string} raw_group_id
 * @returns {string | undefined}
 */
export function normalize_group_id_alias(raw_group_id) {
    const ptr0 = passStringToWasm0(raw_group_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.normalize_group_id_alias(ptr0, len0);
    let v2;
    if (ret[0] !== 0) {
        v2 = getStringFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
    }
    return v2;
}

/**
 * @param {string} thread_key
 * @returns {string | undefined}
 */
export function group_id_from_thread_key(thread_key) {
    const ptr0 = passStringToWasm0(thread_key, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.group_id_from_thread_key(ptr0, len0);
    let v2;
    if (ret[0] !== 0) {
        v2 = getStringFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
    }
    return v2;
}

/**
 * @param {string} raw_group_id
 * @returns {string | undefined}
 */
export function canonical_group_thread_key(raw_group_id) {
    const ptr0 = passStringToWasm0(raw_group_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.canonical_group_thread_key(ptr0, len0);
    let v2;
    if (ret[0] !== 0) {
        v2 = getStringFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
    }
    return v2;
}

function getArrayJsValueFromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    const mem = getDataViewMemory0();
    const result = [];
    for (let i = ptr; i < ptr + 4 * len; i += 4) {
        result.push(wasm.__wbindgen_externrefs.get(mem.getUint32(i, true)));
    }
    wasm.__externref_drop_slice(ptr, len);
    return result;
}
/**
 * @param {string} raw_group_id
 * @returns {string[]}
 */
export function group_id_alias_candidates(raw_group_id) {
    const ptr0 = passStringToWasm0(raw_group_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.group_id_alias_candidates(ptr0, len0);
    var v2 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
    return v2;
}

function passArrayJsValueToWasm0(array, malloc) {
    const ptr = malloc(array.length * 4, 4) >>> 0;
    for (let i = 0; i < array.length; i++) {
        const add = addToExternrefTable0(array[i]);
        getDataViewMemory0().setUint32(ptr + 4 * i, add, true);
    }
    WASM_VECTOR_LEN = array.length;
    return ptr;
}
/**
 * @param {string | null | undefined} payload_key
 * @param {string | null | undefined} stored_current_key
 * @param {string | null | undefined} stored_metadata_key
 * @param {string[]} stored_historical_keys
 * @param {string | null} [community_fallback_key]
 * @returns {string[]}
 */
export function resolve_group_key_candidates(payload_key, stored_current_key, stored_metadata_key, stored_historical_keys, community_fallback_key) {
    var ptr0 = isLikeNone(payload_key) ? 0 : passStringToWasm0(payload_key, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len0 = WASM_VECTOR_LEN;
    var ptr1 = isLikeNone(stored_current_key) ? 0 : passStringToWasm0(stored_current_key, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len1 = WASM_VECTOR_LEN;
    var ptr2 = isLikeNone(stored_metadata_key) ? 0 : passStringToWasm0(stored_metadata_key, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len2 = WASM_VECTOR_LEN;
    const ptr3 = passArrayJsValueToWasm0(stored_historical_keys, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    var ptr4 = isLikeNone(community_fallback_key) ? 0 : passStringToWasm0(community_fallback_key, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len4 = WASM_VECTOR_LEN;
    const ret = wasm.resolve_group_key_candidates(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4);
    var v6 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
    return v6;
}

/**
 * @param {boolean} is_dm
 * @param {boolean} is_community
 * @param {string} thread_name
 * @param {string | null} [community_name]
 * @param {string | null} [contact_full_handle]
 * @param {string | null} [contact_username]
 * @param {string | null} [contact_device_id]
 * @returns {string}
 */
export function thread_display_name(is_dm, is_community, thread_name, community_name, contact_full_handle, contact_username, contact_device_id) {
    let deferred6_0;
    let deferred6_1;
    try {
        const ptr0 = passStringToWasm0(thread_name, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        var ptr1 = isLikeNone(community_name) ? 0 : passStringToWasm0(community_name, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len1 = WASM_VECTOR_LEN;
        var ptr2 = isLikeNone(contact_full_handle) ? 0 : passStringToWasm0(contact_full_handle, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len2 = WASM_VECTOR_LEN;
        var ptr3 = isLikeNone(contact_username) ? 0 : passStringToWasm0(contact_username, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len3 = WASM_VECTOR_LEN;
        var ptr4 = isLikeNone(contact_device_id) ? 0 : passStringToWasm0(contact_device_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len4 = WASM_VECTOR_LEN;
        const ret = wasm.thread_display_name(is_dm, is_community, ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4);
        deferred6_0 = ret[0];
        deferred6_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred6_0, deferred6_1, 1);
    }
}

/**
 * Primary display label for a contact row (handle → device id → user id →
 * "Unknown"). Single source of truth shared with iOS/Android via UniFFI.
 * @param {string | null} [full_handle]
 * @param {string | null} [username]
 * @param {string | null} [discriminator]
 * @param {string | null} [device_id]
 * @param {string | null} [user_id]
 * @returns {string}
 */
export function contact_primary_label(full_handle, username, discriminator, device_id, user_id) {
    let deferred6_0;
    let deferred6_1;
    try {
        var ptr0 = isLikeNone(full_handle) ? 0 : passStringToWasm0(full_handle, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len0 = WASM_VECTOR_LEN;
        var ptr1 = isLikeNone(username) ? 0 : passStringToWasm0(username, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len1 = WASM_VECTOR_LEN;
        var ptr2 = isLikeNone(discriminator) ? 0 : passStringToWasm0(discriminator, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len2 = WASM_VECTOR_LEN;
        var ptr3 = isLikeNone(device_id) ? 0 : passStringToWasm0(device_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len3 = WASM_VECTOR_LEN;
        var ptr4 = isLikeNone(user_id) ? 0 : passStringToWasm0(user_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len4 = WASM_VECTOR_LEN;
        const ret = wasm.contact_primary_label(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4);
        deferred6_0 = ret[0];
        deferred6_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred6_0, deferred6_1, 1);
    }
}

/**
 * Secondary label for a contact row: the @handle only when it adds info the
 * primary line lacks; never the raw user id.
 * @param {string | null} [full_handle]
 * @param {string | null} [username]
 * @param {string | null} [discriminator]
 * @param {string | null} [device_id]
 * @param {string | null} [user_id]
 * @returns {string}
 */
export function contact_secondary_label(full_handle, username, discriminator, device_id, user_id) {
    let deferred6_0;
    let deferred6_1;
    try {
        var ptr0 = isLikeNone(full_handle) ? 0 : passStringToWasm0(full_handle, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len0 = WASM_VECTOR_LEN;
        var ptr1 = isLikeNone(username) ? 0 : passStringToWasm0(username, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len1 = WASM_VECTOR_LEN;
        var ptr2 = isLikeNone(discriminator) ? 0 : passStringToWasm0(discriminator, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len2 = WASM_VECTOR_LEN;
        var ptr3 = isLikeNone(device_id) ? 0 : passStringToWasm0(device_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len3 = WASM_VECTOR_LEN;
        var ptr4 = isLikeNone(user_id) ? 0 : passStringToWasm0(user_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len4 = WASM_VECTOR_LEN;
        const ret = wasm.contact_secondary_label(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4);
        deferred6_0 = ret[0];
        deferred6_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred6_0, deferred6_1, 1);
    }
}

/**
 * @param {number} length
 * @returns {Uint8Array}
 */
export function random_bytes(length) {
    const ret = wasm.random_bytes(length);
    var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
    return v1;
}

/**
 * @param {number} length
 * @returns {string}
 */
export function random_bytes_base64(length) {
    let deferred1_0;
    let deferred1_1;
    try {
        const ret = wasm.random_bytes_base64(length);
        deferred1_0 = ret[0];
        deferred1_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
    }
}

/**
 * Encrypt a file for sending
 * Returns encrypted data (nonce || ciphertext) and base64-encoded key
 * @param {Uint8Array} plaintext
 * @returns {WasmEncryptedAttachment}
 */
export function attachment_encrypt(plaintext) {
    const ptr0 = passArray8ToWasm0(plaintext, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.attachment_encrypt(ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return WasmEncryptedAttachment.__wrap(ret[0]);
}

/**
 * Decrypt a file received from another user
 * Expects combined format (nonce || ciphertext) and base64-encoded key
 * @param {Uint8Array} combined_data
 * @param {string} key_base64
 * @returns {Uint8Array}
 */
export function attachment_decrypt(combined_data, key_base64) {
    const ptr0 = passArray8ToWasm0(combined_data, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(key_base64, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.attachment_decrypt(ptr0, len0, ptr1, len1);
    if (ret[3]) {
        throw takeFromExternrefTable0(ret[2]);
    }
    var v3 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
    return v3;
}

/**
 * Build an encrypted URL by appending the key as a query parameter
 * @param {string} base_url
 * @param {string} key_base64
 * @returns {string}
 */
export function attachment_build_url(base_url, key_base64) {
    let deferred3_0;
    let deferred3_1;
    try {
        const ptr0 = passStringToWasm0(base_url, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(key_base64, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.attachment_build_url(ptr0, len0, ptr1, len1);
        deferred3_0 = ret[0];
        deferred3_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred3_0, deferred3_1, 1);
    }
}

/**
 * Parse an encrypted URL to extract [base_url, key_base64]
 * Returns a JS array with [base_url, key_base64]
 * @param {string} encrypted_url
 * @returns {Array<any>}
 */
export function attachment_parse_url(encrypted_url) {
    const ptr0 = passStringToWasm0(encrypted_url, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.attachment_parse_url(ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Extract just the encryption key from an encrypted URL
 * Returns undefined if no key parameter is found
 * @param {string} encrypted_url
 * @returns {string | undefined}
 */
export function attachment_extract_key(encrypted_url) {
    const ptr0 = passStringToWasm0(encrypted_url, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.attachment_extract_key(ptr0, len0);
    let v2;
    if (ret[0] !== 0) {
        v2 = getStringFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
    }
    return v2;
}

/**
 * Extract the base URL from an encrypted URL (removes the key parameter)
 * Returns undefined if the URL is malformed
 * @param {string} encrypted_url
 * @returns {string | undefined}
 */
export function attachment_extract_base_url(encrypted_url) {
    const ptr0 = passStringToWasm0(encrypted_url, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.attachment_extract_base_url(ptr0, len0);
    let v2;
    if (ret[0] !== 0) {
        v2 = getStringFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
    }
    return v2;
}

/**
 * Derive a keypair from a BIP39 mnemonic phrase using PBKDF2
 *
 * This matches the Web Crypto API PBKDF2 implementation:
 * - 100,000 iterations
 * - SHA-256 hash
 * - Fixed salt: "recovery-keypair-salt"
 *
 * Returns a JS object with { public_key: Uint8Array, secret_key: Uint8Array }
 * @param {string} mnemonic
 * @returns {any}
 */
export function recovery_derive_keypair(mnemonic) {
    const ptr0 = passStringToWasm0(mnemonic, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.recovery_derive_keypair(ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Validate mnemonic format (12 or 24 words)
 * @param {string} mnemonic
 * @returns {boolean}
 */
export function recovery_validate_mnemonic(mnemonic) {
    const ptr0 = passStringToWasm0(mnemonic, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.recovery_validate_mnemonic(ptr0, len0);
    return ret !== 0;
}

/**
 * Verify a `recovery_announce` public key against the server's recorded
 * pubkey for the announcing user. See `verify_recovery_announce_pubkey`
 * in the recovery module for the rule.
 * @param {string} announced_key
 * @param {string} recorded_key
 * @returns {boolean}
 */
export function recovery_verify_announce_pubkey(announced_key, recorded_key) {
    const ptr0 = passStringToWasm0(announced_key, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(recorded_key, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.recovery_verify_announce_pubkey(ptr0, len0, ptr1, len1);
    return ret !== 0;
}

/**
 * Generate a new 12-word BIP39 mnemonic phrase
 *
 * Uses cryptographically secure random entropy to generate a valid
 * BIP39 mnemonic that can be used for account recovery.
 * @returns {string}
 */
export function recovery_generate_mnemonic() {
    let deferred2_0;
    let deferred2_1;
    try {
        const ret = wasm.recovery_generate_mnemonic();
        var ptr1 = ret[0];
        var len1 = ret[1];
        if (ret[3]) {
            ptr1 = 0; len1 = 0;
            throw takeFromExternrefTable0(ret[2]);
        }
        deferred2_0 = ptr1;
        deferred2_1 = len1;
        return getStringFromWasm0(ptr1, len1);
    } finally {
        wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
    }
}

/**
 * Derive the recovery ID from a mnemonic
 *
 * The recovery ID is the base64-encoded public key derived from the mnemonic.
 * This is used as the key to store/retrieve backups on the server.
 * @param {string} mnemonic
 * @returns {string}
 */
export function recovery_derive_recovery_id(mnemonic) {
    let deferred3_0;
    let deferred3_1;
    try {
        const ptr0 = passStringToWasm0(mnemonic, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.recovery_derive_recovery_id(ptr0, len0);
        var ptr2 = ret[0];
        var len2 = ret[1];
        if (ret[3]) {
            ptr2 = 0; len2 = 0;
            throw takeFromExternrefTable0(ret[2]);
        }
        deferred3_0 = ptr2;
        deferred3_1 = len2;
        return getStringFromWasm0(ptr2, len2);
    } finally {
        wasm.__wbindgen_free(deferred3_0, deferred3_1, 1);
    }
}

/**
 * Encrypt backup data using the recovery keypair
 *
 * Takes a mnemonic and arbitrary JSON data, encrypts it, and returns
 * { encryptedData: string, nonce: string, recoveryId: string }
 * @param {string} mnemonic
 * @param {string} data_json
 * @returns {any}
 */
export function recovery_encrypt_backup(mnemonic, data_json) {
    const ptr0 = passStringToWasm0(mnemonic, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(data_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.recovery_encrypt_backup(ptr0, len0, ptr1, len1);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Decrypt backup data using the recovery mnemonic
 *
 * Takes a mnemonic, encrypted data, and nonce, returns the decrypted JSON string
 * @param {string} mnemonic
 * @param {string} encrypted_data_b64
 * @param {string} nonce_b64
 * @returns {string}
 */
export function recovery_decrypt_backup(mnemonic, encrypted_data_b64, nonce_b64) {
    let deferred5_0;
    let deferred5_1;
    try {
        const ptr0 = passStringToWasm0(mnemonic, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(encrypted_data_b64, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ptr2 = passStringToWasm0(nonce_b64, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len2 = WASM_VECTOR_LEN;
        const ret = wasm.recovery_decrypt_backup(ptr0, len0, ptr1, len1, ptr2, len2);
        var ptr4 = ret[0];
        var len4 = ret[1];
        if (ret[3]) {
            ptr4 = 0; len4 = 0;
            throw takeFromExternrefTable0(ret[2]);
        }
        deferred5_0 = ptr4;
        deferred5_1 = len4;
        return getStringFromWasm0(ptr4, len4);
    } finally {
        wasm.__wbindgen_free(deferred5_0, deferred5_1, 1);
    }
}

/**
 * Validate a message JSON and return the parsed message or error
 * @param {string} json
 * @returns {any}
 */
export function validate_message(json) {
    const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.validate_message(ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Validate a user JSON and return the parsed user or error
 * @param {string} json
 * @returns {any}
 */
export function validate_user(json) {
    const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.validate_user(ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Validate a thread/group JSON and return the parsed thread or error
 * @param {string} json
 * @returns {any}
 */
export function validate_thread(json) {
    const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.validate_thread(ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Parse a debug dispatch action JSON and return the parsed action or error.
 * @param {string} json
 * @returns {any}
 */
export function parse_debug_dispatch_action_json(json) {
    const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.parse_debug_dispatch_action_json(ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Parse message JSON without validation (for performance when you trust the source)
 * @param {string} json
 * @returns {any}
 */
export function parse_message(json) {
    const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.parse_message(ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Handle a message from JSON and return core handler results.
 * @param {string} message_json
 * @param {string} current_user_id
 * @returns {any}
 */
export function handle_message_json(message_json, current_user_id) {
    const ptr0 = passStringToWasm0(message_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(current_user_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.handle_message_json(ptr0, len0, ptr1, len1);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Handle an incoming message payload with core decryption + actions.
 * @param {string} payload_json
 * @param {string} current_user_id
 * @param {string} receiver_secret_key_base64
 * @param {string | null} [sender_public_key_base64]
 * @returns {any}
 */
export function handle_incoming_message_json(payload_json, current_user_id, receiver_secret_key_base64, sender_public_key_base64) {
    const ptr0 = passStringToWasm0(payload_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(current_user_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passStringToWasm0(receiver_secret_key_base64, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len2 = WASM_VECTOR_LEN;
    var ptr3 = isLikeNone(sender_public_key_base64) ? 0 : passStringToWasm0(sender_public_key_base64, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len3 = WASM_VECTOR_LEN;
    const ret = wasm.handle_incoming_message_json(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Handle an incoming message payload using device-bound decryption context.
 * @param {string} payload_json
 * @param {string} current_user_id
 * @param {string} receiver_secret_key_base64
 * @param {string | null} [receiver_device_id]
 * @param {string | null} [receiver_ml_kem_public_key_base64]
 * @param {string | null} [receiver_ml_kem_secret_key_base64]
 * @param {string | null} [sender_public_key_base64]
 * @param {string | null} [sender_ml_kem_public_key_base64]
 * @returns {any}
 */
export function handle_incoming_message_json_for_device(payload_json, current_user_id, receiver_secret_key_base64, receiver_device_id, receiver_ml_kem_public_key_base64, receiver_ml_kem_secret_key_base64, sender_public_key_base64, sender_ml_kem_public_key_base64) {
    const ptr0 = passStringToWasm0(payload_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(current_user_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passStringToWasm0(receiver_secret_key_base64, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len2 = WASM_VECTOR_LEN;
    var ptr3 = isLikeNone(receiver_device_id) ? 0 : passStringToWasm0(receiver_device_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len3 = WASM_VECTOR_LEN;
    var ptr4 = isLikeNone(receiver_ml_kem_public_key_base64) ? 0 : passStringToWasm0(receiver_ml_kem_public_key_base64, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len4 = WASM_VECTOR_LEN;
    var ptr5 = isLikeNone(receiver_ml_kem_secret_key_base64) ? 0 : passStringToWasm0(receiver_ml_kem_secret_key_base64, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len5 = WASM_VECTOR_LEN;
    var ptr6 = isLikeNone(sender_public_key_base64) ? 0 : passStringToWasm0(sender_public_key_base64, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len6 = WASM_VECTOR_LEN;
    var ptr7 = isLikeNone(sender_ml_kem_public_key_base64) ? 0 : passStringToWasm0(sender_ml_kem_public_key_base64, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len7 = WASM_VECTOR_LEN;
    const ret = wasm.handle_incoming_message_json_for_device(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4, ptr5, len5, ptr6, len6, ptr7, len7);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Parse user JSON without validation
 * @param {string} json
 * @returns {any}
 */
export function parse_user(json) {
    const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.parse_user(ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Parse thread JSON without validation
 * @param {string} json
 * @returns {any}
 */
export function parse_thread(json) {
    const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.parse_thread(ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Serialize a message object to JSON string
 * @param {any} msg
 * @returns {string}
 */
export function stringify_message(msg) {
    let deferred2_0;
    let deferred2_1;
    try {
        const ret = wasm.stringify_message(msg);
        var ptr1 = ret[0];
        var len1 = ret[1];
        if (ret[3]) {
            ptr1 = 0; len1 = 0;
            throw takeFromExternrefTable0(ret[2]);
        }
        deferred2_0 = ptr1;
        deferred2_1 = len1;
        return getStringFromWasm0(ptr1, len1);
    } finally {
        wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
    }
}

/**
 * Serialize a user object to JSON string
 * @param {any} user
 * @returns {string}
 */
export function stringify_user(user) {
    let deferred2_0;
    let deferred2_1;
    try {
        const ret = wasm.stringify_user(user);
        var ptr1 = ret[0];
        var len1 = ret[1];
        if (ret[3]) {
            ptr1 = 0; len1 = 0;
            throw takeFromExternrefTable0(ret[2]);
        }
        deferred2_0 = ptr1;
        deferred2_1 = len1;
        return getStringFromWasm0(ptr1, len1);
    } finally {
        wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
    }
}

/**
 * Parse a handle string (username.1234) into username and discriminator
 * Returns null if the handle is invalid
 * @param {string} handle
 * @returns {any}
 */
export function parse_handle(handle) {
    const ptr0 = passStringToWasm0(handle, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.parse_handle(ptr0, len0);
    return ret;
}

/**
 * Create a handle string from username and discriminator
 * @param {string} username
 * @param {string} discriminator
 * @returns {string}
 */
export function create_handle(username, discriminator) {
    let deferred3_0;
    let deferred3_1;
    try {
        const ptr0 = passStringToWasm0(username, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(discriminator, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.create_handle(ptr0, len0, ptr1, len1);
        deferred3_0 = ret[0];
        deferred3_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred3_0, deferred3_1, 1);
    }
}

/**
 * Validate a username (returns error message or null if valid)
 * @param {string} username
 * @returns {any}
 */
export function validate_username(username) {
    const ptr0 = passStringToWasm0(username, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.validate_username(ptr0, len0);
    return ret;
}

/**
 * Validate a discriminator (returns error message or null if valid)
 * @param {string} discriminator
 * @returns {any}
 */
export function validate_discriminator(discriminator) {
    const ptr0 = passStringToWasm0(discriminator, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.validate_discriminator(ptr0, len0);
    return ret;
}

/**
 * Get the handle from a user object (returns username.discriminator or just username or null)
 * @param {any} user
 * @returns {any}
 */
export function get_user_handle(user) {
    const ret = wasm.get_user_handle(user);
    return ret;
}

/**
 * Validate a user for client JSON and return the parsed user or error
 * @param {string} json
 * @returns {any}
 */
export function validate_user_for_client(json) {
    const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.validate_user_for_client(ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Parse user for client JSON without validation
 * @param {string} json
 * @returns {any}
 */
export function parse_user_for_client(json) {
    const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.parse_user_for_client(ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Validate a community JSON and return the parsed community or error
 * @param {string} json
 * @returns {any}
 */
export function validate_community(json) {
    const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.validate_community(ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Parse community JSON without validation
 * @param {string} json
 * @returns {any}
 */
export function parse_community(json) {
    const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.parse_community(ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Serialize a community object to JSON string
 * @param {any} community
 * @returns {string}
 */
export function stringify_community(community) {
    let deferred2_0;
    let deferred2_1;
    try {
        const ret = wasm.stringify_community(community);
        var ptr1 = ret[0];
        var len1 = ret[1];
        if (ret[3]) {
            ptr1 = 0; len1 = 0;
            throw takeFromExternrefTable0(ret[2]);
        }
        deferred2_0 = ptr1;
        deferred2_1 = len1;
        return getStringFromWasm0(ptr1, len1);
    } finally {
        wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
    }
}

/**
 * Parse community update payload JSON without validation
 * @param {string} json
 * @returns {any}
 */
export function parse_community_update_payload(json) {
    const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.parse_community_update_payload(ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Serialize a community update payload object to JSON string
 * @param {any} payload
 * @returns {string}
 */
export function stringify_community_update_payload(payload) {
    let deferred2_0;
    let deferred2_1;
    try {
        const ret = wasm.stringify_community_update_payload(payload);
        var ptr1 = ret[0];
        var len1 = ret[1];
        if (ret[3]) {
            ptr1 = 0; len1 = 0;
            throw takeFromExternrefTable0(ret[2]);
        }
        deferred2_0 = ptr1;
        deferred2_1 = len1;
        return getStringFromWasm0(ptr1, len1);
    } finally {
        wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
    }
}

/**
 * Validate a token JSON and return the parsed token or error
 * @param {string} json
 * @returns {any}
 */
export function validate_token(json) {
    const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.validate_token(ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Parse token JSON without validation
 * @param {string} json
 * @returns {any}
 */
export function parse_token(json) {
    const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.parse_token(ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Validate a push token JSON and return the parsed push token or error
 * @param {string} json
 * @returns {any}
 */
export function validate_push_token(json) {
    const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.validate_push_token(ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Validate a member JSON and return the parsed member or error
 * @param {string} json
 * @returns {any}
 */
export function validate_member(json) {
    const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.validate_member(ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Parse member JSON without validation
 * @param {string} json
 * @returns {any}
 */
export function parse_member(json) {
    const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.parse_member(ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Serialize a thread object to JSON string
 * @param {any} thread
 * @returns {string}
 */
export function stringify_thread(thread) {
    let deferred2_0;
    let deferred2_1;
    try {
        const ret = wasm.stringify_thread(thread);
        var ptr1 = ret[0];
        var len1 = ret[1];
        if (ret[3]) {
            ptr1 = 0; len1 = 0;
            throw takeFromExternrefTable0(ret[2]);
        }
        deferred2_0 = ptr1;
        deferred2_1 = len1;
        return getStringFromWasm0(ptr1, len1);
    } finally {
        wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
    }
}

/**
 * Parse a WebSocket event type string
 * @param {string} event_type
 * @returns {any}
 */
export function parse_event_type(event_type) {
    const ptr0 = passStringToWasm0(event_type, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.parse_event_type(ptr0, len0);
    return ret;
}

/**
 * Return the core-owned product event/effect inventory as JSON.
 * @returns {string}
 */
export function product_event_inventory_json() {
    let deferred2_0;
    let deferred2_1;
    try {
        const ret = wasm.product_event_inventory_json();
        var ptr1 = ret[0];
        var len1 = ret[1];
        if (ret[3]) {
            ptr1 = 0; len1 = 0;
            throw takeFromExternrefTable0(ret[2]);
        }
        deferred2_0 = ptr1;
        deferred2_1 = len1;
        return getStringFromWasm0(ptr1, len1);
    } finally {
        wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
    }
}

/**
 * Configure the API client
 * @param {string} base_url
 * @param {string | null} [token]
 */
export function api_configure(base_url, token) {
    const ptr0 = passStringToWasm0(base_url, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    var ptr1 = isLikeNone(token) ? 0 : passStringToWasm0(token, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len1 = WASM_VECTOR_LEN;
    wasm.api_configure(ptr0, len0, ptr1, len1);
}

/**
 * Update the API auth token
 * @param {string | null} [token]
 */
export function api_set_token(token) {
    var ptr0 = isLikeNone(token) ? 0 : passStringToWasm0(token, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len0 = WASM_VECTOR_LEN;
    wasm.api_set_token(ptr0, len0);
}

/**
 * Register a new device
 * @param {string} username
 * @param {string} app_id
 * @param {string} public_key
 * @returns {Promise<any>}
 */
export function api_register(username, app_id, public_key) {
    const ptr0 = passStringToWasm0(username, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(app_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passStringToWasm0(public_key, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len2 = WASM_VECTOR_LEN;
    const ret = wasm.api_register(ptr0, len0, ptr1, len1, ptr2, len2);
    return ret;
}

/**
 * Register a new device with optional ML-KEM public key.
 * @param {string} username
 * @param {string} app_id
 * @param {string} public_key
 * @param {string | null} [ml_kem_public_key]
 * @returns {Promise<any>}
 */
export function api_register_with_ml_kem(username, app_id, public_key, ml_kem_public_key) {
    const ptr0 = passStringToWasm0(username, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(app_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passStringToWasm0(public_key, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len2 = WASM_VECTOR_LEN;
    var ptr3 = isLikeNone(ml_kem_public_key) ? 0 : passStringToWasm0(ml_kem_public_key, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len3 = WASM_VECTOR_LEN;
    const ret = wasm.api_register_with_ml_kem(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3);
    return ret;
}

/**
 * Register a new user (requires auth)
 * @param {string} username
 * @returns {Promise<any>}
 */
export function api_register_user(username) {
    const ptr0 = passStringToWasm0(username, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.api_register_user(ptr0, len0);
    return ret;
}

/**
 * Register user with discriminator (requires auth)
 * @param {string} username
 * @returns {Promise<any>}
 */
export function api_register_user_with_discriminator(username) {
    const ptr0 = passStringToWasm0(username, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.api_register_user_with_discriminator(ptr0, len0);
    return ret;
}

/**
 * Find user by handle (requires auth)
 * @param {string} handle
 * @returns {Promise<any>}
 */
export function api_find_user(handle) {
    const ptr0 = passStringToWasm0(handle, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.api_find_user(ptr0, len0);
    return ret;
}

/**
 * Search user by username (requires auth)
 * @param {string} username
 * @returns {Promise<any>}
 */
export function api_search_user(username) {
    const ptr0 = passStringToWasm0(username, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.api_search_user(ptr0, len0);
    return ret;
}

/**
 * Search user by ID (requires auth)
 * @param {string} user_id
 * @returns {Promise<any>}
 */
export function api_search_user_id(user_id) {
    const ptr0 = passStringToWasm0(user_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.api_search_user_id(ptr0, len0);
    return ret;
}

/**
 * Search user by device ID (requires auth)
 * @param {string} device_id
 * @returns {Promise<any>}
 */
export function api_search_primary_device_id(device_id) {
    const ptr0 = passStringToWasm0(device_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.api_search_primary_device_id(ptr0, len0);
    return ret;
}

/**
 * Search user by username and discriminator (requires auth)
 * @param {string} username
 * @param {string} discriminator
 * @returns {Promise<any>}
 */
export function api_search_user_discriminator(username, discriminator) {
    const ptr0 = passStringToWasm0(username, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(discriminator, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.api_search_user_discriminator(ptr0, len0, ptr1, len1);
    return ret;
}

/**
 * Set display photo (requires auth)
 * @param {string} url
 * @returns {Promise<any>}
 */
export function api_set_display_photo(url) {
    const ptr0 = passStringToWasm0(url, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.api_set_display_photo(ptr0, len0);
    return ret;
}

/**
 * Set display photo with canonical media metadata (requires auth)
 * @param {any} display_photo_media
 * @returns {Promise<any>}
 */
export function api_set_display_photo_with_media(display_photo_media) {
    const ret = wasm.api_set_display_photo_with_media(display_photo_media);
    return ret;
}

/**
 * Get a group by ID (requires auth)
 * @param {string} group_id
 * @returns {Promise<any>}
 */
export function api_get_group(group_id) {
    const ptr0 = passStringToWasm0(group_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.api_get_group(ptr0, len0);
    return ret;
}

/**
 * Create or update a group (requires auth)
 * @param {any} group
 * @param {string | null | undefined} signature
 * @param {string | null | undefined} signing_public_key
 * @param {any} writer_keys
 * @returns {Promise<any>}
 */
export function api_create_or_update_group(group, signature, signing_public_key, writer_keys) {
    var ptr0 = isLikeNone(signature) ? 0 : passStringToWasm0(signature, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len0 = WASM_VECTOR_LEN;
    var ptr1 = isLikeNone(signing_public_key) ? 0 : passStringToWasm0(signing_public_key, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len1 = WASM_VECTOR_LEN;
    const ret = wasm.api_create_or_update_group(group, ptr0, len0, ptr1, len1, writer_keys);
    return ret;
}

/**
 * Create a new group with generated key, encrypt, and sync to API
 *
 * This is a high-level function that handles:
 * 1. Creating a Thread with a generated symmetric group key
 * 2. Encrypting the thread data
 * 3. Syncing to the server API
 *
 * Returns the created Thread object (with the group key)
 * Membership is included in the encrypted payload for zero-knowledge groups.
 * @param {string} name
 * @param {string | null | undefined} description
 * @param {string} owner_id
 * @returns {Promise<any>}
 */
export function create_group(name, description, owner_id) {
    const ptr0 = passStringToWasm0(name, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    var ptr1 = isLikeNone(description) ? 0 : passStringToWasm0(description, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len1 = WASM_VECTOR_LEN;
    const ptr2 = passStringToWasm0(owner_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len2 = WASM_VECTOR_LEN;
    const ret = wasm.create_group(ptr0, len0, ptr1, len1, ptr2, len2);
    return ret;
}

/**
 * Legacy alias for `create_group`.
 *
 * Historically this variant excluded members from encrypted thread metadata.
 * It now follows the same zero-knowledge behavior as `create_group`.
 *
 * Returns the created Thread object (with the group key)
 * @param {string} name
 * @param {string | null | undefined} description
 * @param {string} owner_id
 * @returns {Promise<any>}
 */
export function create_group_aligned(name, description, owner_id) {
    const ptr0 = passStringToWasm0(name, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    var ptr1 = isLikeNone(description) ? 0 : passStringToWasm0(description, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len1 = WASM_VECTOR_LEN;
    const ptr2 = passStringToWasm0(owner_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len2 = WASM_VECTOR_LEN;
    const ret = wasm.create_group_aligned(ptr0, len0, ptr1, len1, ptr2, len2);
    return ret;
}

/**
 * Create a group thread locally without syncing to API
 *
 * Returns the Thread object with a generated group key.
 * Use this when you want to create a group offline or handle syncing separately.
 * @param {string} name
 * @param {string | null | undefined} description
 * @param {string} owner_id
 * @returns {any}
 */
export function create_group_thread(name, description, owner_id) {
    const ptr0 = passStringToWasm0(name, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    var ptr1 = isLikeNone(description) ? 0 : passStringToWasm0(description, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len1 = WASM_VECTOR_LEN;
    const ptr2 = passStringToWasm0(owner_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len2 = WASM_VECTOR_LEN;
    const ret = wasm.create_group_thread(ptr0, len0, ptr1, len1, ptr2, len2);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Encrypt a Thread to create an EncryptedThread for API
 * Group membership is included in encrypted payloads for zero-knowledge behavior.
 * @param {any} thread
 * @returns {any}
 */
export function encrypt_thread_for_api(thread) {
    const ret = wasm.encrypt_thread_for_api(thread);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Legacy compatibility alias for thread encryption.
 * This now matches `encrypt_thread_for_api` to avoid dropping encrypted members.
 * @param {any} thread
 * @returns {any}
 */
export function encrypt_thread_for_api_without_members(thread) {
    const ret = wasm.encrypt_thread_for_api_without_members(thread);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Encrypt a member list for private groups.
 * Takes an array of Member objects and a base64-encoded group key.
 * Returns an EncryptedMembers object.
 * @param {any} members
 * @param {string} group_key
 * @returns {any}
 */
export function encrypt_members(members, group_key) {
    const ptr0 = passStringToWasm0(group_key, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.encrypt_members(members, ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Decrypt a member list for private groups.
 * Takes an EncryptedMembers object and a base64-encoded group key.
 * Returns an array of Member objects.
 * @param {any} encrypted
 * @param {string} group_key
 * @returns {any}
 */
export function decrypt_members(encrypted, group_key) {
    const ptr0 = passStringToWasm0(group_key, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.decrypt_members(encrypted, ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Decrypt an EncryptedThread blob back into a Thread.
 *
 * Takes an EncryptedThread object and a base64-encoded group key (typically version 1).
 * Returns the decrypted Thread object.
 * @param {any} encrypted
 * @param {string} group_key_base64
 * @returns {any}
 */
export function decrypt_thread(encrypted, group_key_base64) {
    const ptr0 = passStringToWasm0(group_key_base64, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.decrypt_thread(encrypted, ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Rotate the group key, generating a new version.
 *
 * Takes a Thread object, rotates its key, and returns an object with:
 * - `thread`: the updated Thread with new key version
 * - `rotation`: { newKey, newVersion, metadataKey }
 * @param {any} thread
 * @returns {any}
 */
export function rotate_group_key(thread) {
    const ret = wasm.rotate_group_key(thread);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Get keys to distribute to a new member.
 *
 * Returns a map of version -> base64 key.
 * Includes version 1 (metadata) and current version (new messages).
 * @param {any} thread
 * @returns {any}
 */
export function get_keys_for_new_member(thread) {
    const ret = wasm.get_keys_for_new_member(thread);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Get the current key for message encryption.
 *
 * Returns { key: string, version: number }.
 * @param {any} thread
 * @returns {any}
 */
export function get_current_message_key(thread) {
    const ret = wasm.get_current_message_key(thread);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Get a specific key version for message decryption.
 *
 * Returns the base64-encoded key for the given version.
 * @param {any} thread
 * @param {number} version
 * @returns {string}
 */
export function get_key_by_version(thread, version) {
    let deferred2_0;
    let deferred2_1;
    try {
        const ret = wasm.get_key_by_version(thread, version);
        var ptr1 = ret[0];
        var len1 = ret[1];
        if (ret[3]) {
            ptr1 = 0; len1 = 0;
            throw takeFromExternrefTable0(ret[2]);
        }
        deferred2_0 = ptr1;
        deferred2_1 = len1;
        return getStringFromWasm0(ptr1, len1);
    } finally {
        wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
    }
}

/**
 * Get a community by ID (requires auth)
 * @param {string} community_id
 * @returns {Promise<any>}
 */
export function api_get_community(community_id) {
    const ptr0 = passStringToWasm0(community_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.api_get_community(ptr0, len0);
    return ret;
}

/**
 * Create or update a community (requires auth)
 * @param {any} community
 * @param {string | null | undefined} signature
 * @param {string | null | undefined} signing_public_key
 * @param {any} writer_keys
 * @returns {Promise<any>}
 */
export function api_create_or_update_community(community, signature, signing_public_key, writer_keys) {
    var ptr0 = isLikeNone(signature) ? 0 : passStringToWasm0(signature, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len0 = WASM_VECTOR_LEN;
    var ptr1 = isLikeNone(signing_public_key) ? 0 : passStringToWasm0(signing_public_key, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len1 = WASM_VECTOR_LEN;
    const ret = wasm.api_create_or_update_community(community, ptr0, len0, ptr1, len1, writer_keys);
    return ret;
}

/**
 * List user communities (requires auth)
 * @param {string | null} [user_id]
 * @returns {Promise<any>}
 */
export function api_list_user_communities(user_id) {
    var ptr0 = isLikeNone(user_id) ? 0 : passStringToWasm0(user_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len0 = WASM_VECTOR_LEN;
    const ret = wasm.api_list_user_communities(ptr0, len0);
    return ret;
}

/**
 * Leave a community (requires auth)
 * @param {string} community_id
 * @returns {Promise<any>}
 */
export function api_leave_community(community_id) {
    const ptr0 = passStringToWasm0(community_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.api_leave_community(ptr0, len0);
    return ret;
}

/**
 * Add a member to a community (requires auth)
 * @param {string} community_id
 * @param {string} user_id
 * @param {string | null} [role]
 * @returns {Promise<any>}
 */
export function api_add_community_member(community_id, user_id, role) {
    const ptr0 = passStringToWasm0(community_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(user_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    var ptr2 = isLikeNone(role) ? 0 : passStringToWasm0(role, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len2 = WASM_VECTOR_LEN;
    const ret = wasm.api_add_community_member(ptr0, len0, ptr1, len1, ptr2, len2);
    return ret;
}

/**
 * Join a community group (requires auth)
 * @param {string} community_id
 * @param {string} group_id
 * @returns {Promise<any>}
 */
export function api_join_community_group(community_id, group_id) {
    const ptr0 = passStringToWasm0(community_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(group_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.api_join_community_group(ptr0, len0, ptr1, len1);
    return ret;
}

/**
 * Delete a community (requires auth)
 * @param {string} community_id
 * @returns {Promise<any>}
 */
export function api_delete_community(community_id) {
    const ptr0 = passStringToWasm0(community_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.api_delete_community(ptr0, len0);
    return ret;
}

/**
 * Get group members (deprecated; disabled for zero-knowledge groups)
 * @param {string} group_id
 * @returns {Promise<any>}
 */
export function api_get_group_members(group_id) {
    const ptr0 = passStringToWasm0(group_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.api_get_group_members(ptr0, len0);
    return ret;
}

/**
 * Set (replace) group members (deprecated; disabled for zero-knowledge groups)
 * @param {string} group_id
 * @param {any} members
 * @returns {Promise<any>}
 */
export function api_set_group_members(group_id, members) {
    const ptr0 = passStringToWasm0(group_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.api_set_group_members(ptr0, len0, members);
    return ret;
}

/**
 * Add a member to a group (deprecated; disabled for zero-knowledge groups)
 * @param {string} group_id
 * @param {string} user_id
 * @param {string | null} [role]
 * @returns {Promise<any>}
 */
export function api_add_group_member(group_id, user_id, role) {
    const ptr0 = passStringToWasm0(group_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(user_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    var ptr2 = isLikeNone(role) ? 0 : passStringToWasm0(role, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len2 = WASM_VECTOR_LEN;
    const ret = wasm.api_add_group_member(ptr0, len0, ptr1, len1, ptr2, len2);
    return ret;
}

/**
 * Remove a member from a group (deprecated; disabled for zero-knowledge groups)
 * @param {string} group_id
 * @param {string} user_id
 * @returns {Promise<any>}
 */
export function api_remove_group_member(group_id, user_id) {
    const ptr0 = passStringToWasm0(group_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(user_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.api_remove_group_member(ptr0, len0, ptr1, len1);
    return ret;
}

/**
 * Get community members (requires auth)
 * @param {string} community_id
 * @returns {Promise<any>}
 */
export function api_get_community_members(community_id) {
    const ptr0 = passStringToWasm0(community_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.api_get_community_members(ptr0, len0);
    return ret;
}

/**
 * Set (replace) community members (requires auth)
 * @param {string} community_id
 * @param {any} members
 * @returns {Promise<any>}
 */
export function api_set_community_members(community_id, members) {
    const ptr0 = passStringToWasm0(community_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.api_set_community_members(ptr0, len0, members);
    return ret;
}

/**
 * Remove a member from a community (requires auth)
 * @param {string} community_id
 * @param {string} user_id
 * @returns {Promise<any>}
 */
export function api_remove_community_member(community_id, user_id) {
    const ptr0 = passStringToWasm0(community_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(user_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.api_remove_community_member(ptr0, len0, ptr1, len1);
    return ret;
}

/**
 * Fetch messages (requires auth)
 * @returns {Promise<any>}
 */
export function api_fetch_messages() {
    const ret = wasm.api_fetch_messages();
    return ret;
}

/**
 * Get presigned upload URL (requires auth)
 * @param {string} filename
 * @returns {Promise<any>}
 */
export function api_get_presigned_url(filename) {
    const ptr0 = passStringToWasm0(filename, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.api_get_presigned_url(ptr0, len0);
    return ret;
}

/**
 * Remove an object from storage (requires auth)
 * @param {string} key
 * @returns {Promise<any>}
 */
export function api_remove_object(key) {
    const ptr0 = passStringToWasm0(key, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.api_remove_object(ptr0, len0);
    return ret;
}

/**
 * Store recovery backup (requires auth)
 * @param {string} recovery_id
 * @param {string} encrypted_data
 * @param {string} nonce
 * @returns {Promise<any>}
 */
export function api_store_recovery_backup(recovery_id, encrypted_data, nonce) {
    const ptr0 = passStringToWasm0(recovery_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(encrypted_data, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passStringToWasm0(nonce, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len2 = WASM_VECTOR_LEN;
    const ret = wasm.api_store_recovery_backup(ptr0, len0, ptr1, len1, ptr2, len2);
    return ret;
}

/**
 * Get recovery backup
 * @param {string} recovery_id
 * @param {string} app_id
 * @returns {Promise<any>}
 */
export function api_get_recovery_backup(recovery_id, app_id) {
    const ptr0 = passStringToWasm0(recovery_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(app_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.api_get_recovery_backup(ptr0, len0, ptr1, len1);
    return ret;
}

/**
 * Restore session from recovery backup.
 *
 * Takes the recovery `mnemonic` (not `recovery_id`): the restore flow now
 * proves possession of the mnemonic-derived recovery secret key via a
 * challenge round-trip. The mnemonic stays in-core and is never sent; only
 * the decrypted challenge plaintext leaves the device.
 * @param {string} mnemonic
 * @param {string} app_id
 * @returns {Promise<any>}
 */
export function api_restore_session(mnemonic, app_id) {
    const ptr0 = passStringToWasm0(mnemonic, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(app_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.api_restore_session(ptr0, len0, ptr1, len1);
    return ret;
}

/**
 * Prepare an encrypted display photo upload
 *
 * Encrypts the photo, fetches a presigned URL, and returns:
 * { uploadUrl, cleanUrl, encryptedData (Uint8Array), keyBase64, mimeType }
 * @param {Uint8Array} photo
 * @returns {Promise<any>}
 */
export function prepare_display_photo_upload(photo) {
    const ptr0 = passArray8ToWasm0(photo, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.prepare_display_photo_upload(ptr0, len0);
    return ret;
}

/**
 * Delete recovery backup (requires auth)
 * @param {string} recovery_id
 * @returns {Promise<any>}
 */
export function api_delete_recovery_backup(recovery_id) {
    const ptr0 = passStringToWasm0(recovery_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.api_delete_recovery_backup(ptr0, len0);
    return ret;
}

/**
 * Get cache paths for a display photo (per-user and URL-based)
 * @param {string} user_id
 * @param {string} clean_url
 * @returns {any}
 */
export function display_photo_cache_paths(user_id, clean_url) {
    const ptr0 = passStringToWasm0(user_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(clean_url, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.display_photo_cache_paths(ptr0, len0, ptr1, len1);
    return ret;
}

/**
 * Prepare a contact-add payload (shares display photo info)
 * @param {string} user_id
 * @param {string | null | undefined} display_photo_url
 * @param {string | null | undefined} display_photo_key
 * @param {string} receiver_id
 * @param {string} receiver_public_key_base64
 * @param {string} my_user_id
 * @param {string} my_secret_key_base64
 * @returns {any}
 */
export function prepare_contact_add_message(user_id, display_photo_url, display_photo_key, receiver_id, receiver_public_key_base64, my_user_id, my_secret_key_base64) {
    const ptr0 = passStringToWasm0(user_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    var ptr1 = isLikeNone(display_photo_url) ? 0 : passStringToWasm0(display_photo_url, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len1 = WASM_VECTOR_LEN;
    var ptr2 = isLikeNone(display_photo_key) ? 0 : passStringToWasm0(display_photo_key, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len2 = WASM_VECTOR_LEN;
    const ptr3 = passStringToWasm0(receiver_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len3 = WASM_VECTOR_LEN;
    const ptr4 = passStringToWasm0(receiver_public_key_base64, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len4 = WASM_VECTOR_LEN;
    const ptr5 = passStringToWasm0(my_user_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len5 = WASM_VECTOR_LEN;
    const ptr6 = passStringToWasm0(my_secret_key_base64, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len6 = WASM_VECTOR_LEN;
    const ret = wasm.prepare_contact_add_message(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4, ptr5, len5, ptr6, len6);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Get call token (requires auth)
 * @param {string} room_name
 * @returns {Promise<any>}
 */
export function api_get_call_token(room_name) {
    const ptr0 = passStringToWasm0(room_name, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.api_get_call_token(ptr0, len0);
    return ret;
}

/**
 * Register platform push token (requires auth)
 * @param {string} device_id
 * @param {string} token
 * @param {string} platform
 * @returns {Promise<any>}
 */
export function api_register_platform_push_token(device_id, token, platform) {
    const ptr0 = passStringToWasm0(device_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(token, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passStringToWasm0(platform, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len2 = WASM_VECTOR_LEN;
    const ret = wasm.api_register_platform_push_token(ptr0, len0, ptr1, len1, ptr2, len2);
    return ret;
}

/**
 * Logout - disconnects and clears auth token
 * @returns {Promise<void>}
 */
export function logout() {
    const ret = wasm.logout();
    return ret;
}

/**
 * Create a new WebSocket client
 * @param {string} url
 * @param {string | null} [token]
 */
export function ws_create(url, token) {
    const ptr0 = passStringToWasm0(url, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    var ptr1 = isLikeNone(token) ? 0 : passStringToWasm0(token, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len1 = WASM_VECTOR_LEN;
    wasm.ws_create(ptr0, len0, ptr1, len1);
}

/**
 * Set the WebSocket event callback
 * The callback will receive a JSON string with the event data
 * @param {Function} callback
 */
export function ws_on_event(callback) {
    wasm.ws_on_event(callback);
}

/**
 * Connect to WebSocket server
 * @returns {Promise<void>}
 */
export function ws_connect() {
    const ret = wasm.ws_connect();
    return ret;
}

/**
 * Check if WebSocket is connected
 * @returns {boolean}
 */
export function ws_is_connected() {
    const ret = wasm.ws_is_connected();
    return ret !== 0;
}

/**
 * Send a raw WebSocket message
 * @param {string} message
 * @returns {Promise<void>}
 */
export function ws_send_raw(message) {
    const ptr0 = passStringToWasm0(message, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.ws_send_raw(ptr0, len0);
    return ret;
}

/**
 * Send a chat message via WebSocket
 * encrypted_content and nonce should come from encrypt_message_base64()
 * @param {string} message_id
 * @param {string} receiver_id
 * @param {string} encrypted_content
 * @param {string} nonce
 * @param {string | null} [thread_key]
 * @returns {Promise<void>}
 */
export function ws_send_message(message_id, receiver_id, encrypted_content, nonce, thread_key) {
    const ptr0 = passStringToWasm0(message_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(receiver_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passStringToWasm0(encrypted_content, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passStringToWasm0(nonce, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len3 = WASM_VECTOR_LEN;
    var ptr4 = isLikeNone(thread_key) ? 0 : passStringToWasm0(thread_key, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len4 = WASM_VECTOR_LEN;
    const ret = wasm.ws_send_message(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4);
    return ret;
}

/**
 * Acknowledge a received message
 * @param {string} message_id
 * @returns {Promise<void>}
 */
export function ws_ack_message(message_id) {
    const ptr0 = passStringToWasm0(message_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.ws_ack_message(ptr0, len0);
    return ret;
}

/**
 * Send pong response
 * @param {number} timestamp
 * @returns {Promise<void>}
 */
export function ws_pong(timestamp) {
    const ret = wasm.ws_pong(timestamp);
    return ret;
}

/**
 * Get default WebSocket config as JSON (for platform-specific timers).
 * @returns {string}
 */
export function ws_default_config_json() {
    let deferred1_0;
    let deferred1_1;
    try {
        const ret = wasm.ws_default_config_json();
        deferred1_0 = ret[0];
        deferred1_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
    }
}

/**
 * Disconnect WebSocket
 * @returns {string}
 */
export function ws_disconnect() {
    let deferred1_0;
    let deferred1_1;
    try {
        const ret = wasm.ws_disconnect();
        deferred1_0 = ret[0];
        deferred1_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
    }
}

/**
 * Destroy the WebSocket client
 */
export function ws_destroy() {
    wasm.ws_destroy();
}

/**
 * Hash a HiLo code (for verification)
 * @param {string} code
 * @returns {string}
 */
export function hilo_hash_code(code) {
    let deferred2_0;
    let deferred2_1;
    try {
        const ptr0 = passStringToWasm0(code, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.hilo_hash_code(ptr0, len0);
        deferred2_0 = ret[0];
        deferred2_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
    }
}

/**
 * Decrypt a received DM message
 * @param {string} encrypted_content_base64
 * @param {string} nonce_base64
 * @param {string} sender_public_key_base64
 * @param {string} my_secret_key_base64
 * @returns {WasmDecryptedMessage}
 */
export function decrypt_received_dm(encrypted_content_base64, nonce_base64, sender_public_key_base64, my_secret_key_base64) {
    const ptr0 = passStringToWasm0(encrypted_content_base64, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(nonce_base64, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passStringToWasm0(sender_public_key_base64, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passStringToWasm0(my_secret_key_base64, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len3 = WASM_VECTOR_LEN;
    const ret = wasm.decrypt_received_dm(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3);
    return WasmDecryptedMessage.__wrap(ret);
}

/**
 * Parse attachment content from message JSON
 * @param {string} content
 * @returns {any}
 */
export function parse_attachment_content(content) {
    const ptr0 = passStringToWasm0(content, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.parse_attachment_content(ptr0, len0);
    return ret;
}

/**
 * Build attachment content JSON
 * @param {string} id
 * @param {string} encrypted_url
 * @param {string} filename
 * @param {bigint} size
 * @param {string} mime_type
 * @returns {string}
 */
export function build_attachment_content(id, encrypted_url, filename, size, mime_type) {
    let deferred5_0;
    let deferred5_1;
    try {
        const ptr0 = passStringToWasm0(id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(encrypted_url, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ptr2 = passStringToWasm0(filename, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len2 = WASM_VECTOR_LEN;
        const ptr3 = passStringToWasm0(mime_type, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len3 = WASM_VECTOR_LEN;
        const ret = wasm.build_attachment_content(ptr0, len0, ptr1, len1, ptr2, len2, size, ptr3, len3);
        deferred5_0 = ret[0];
        deferred5_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred5_0, deferred5_1, 1);
    }
}

/**
 * Check if content is an attachment JSON
 * @param {string} content
 * @returns {boolean}
 */
export function is_attachment_content(content) {
    const ptr0 = passStringToWasm0(content, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.is_attachment_content(ptr0, len0);
    return ret !== 0;
}

/**
 * Build the versioned content envelope plaintext to encrypt for a message.
 *
 * `content_type` is the wire content type (e.g. "TEXT", "FILE", "CALL");
 * core derives the envelope kind and strips the environment for control
 * messages. `environment` is the current HiLo environment ("hi"/"lo") or
 * empty/`null`.
 * @param {string} content
 * @param {string} content_type
 * @param {string | null} [environment]
 * @returns {string}
 */
export function build_message_content(content, content_type, environment) {
    let deferred4_0;
    let deferred4_1;
    try {
        const ptr0 = passStringToWasm0(content, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(content_type, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        var ptr2 = isLikeNone(environment) ? 0 : passStringToWasm0(environment, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len2 = WASM_VECTOR_LEN;
        const ret = wasm.build_message_content(ptr0, len0, ptr1, len1, ptr2, len2);
        deferred4_0 = ret[0];
        deferred4_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred4_0, deferred4_1, 1);
    }
}

/**
 * Parse decrypted plaintext into `{ content, kind, environment }`.
 *
 * Recognizes the versioned content envelope and falls back to legacy
 * raw-text or bare-attachment-JSON content.
 * @param {string} decrypted
 * @returns {any}
 */
export function parse_message_content(decrypted) {
    const ptr0 = passStringToWasm0(decrypted, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.parse_message_content(ptr0, len0);
    return ret;
}

/**
 * Parse JWT token payload (does NOT verify signature)
 * @param {string} token
 * @returns {any}
 */
export function parse_jwt_payload(token) {
    const ptr0 = passStringToWasm0(token, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.parse_jwt_payload(ptr0, len0);
    return ret;
}

/**
 * Get user ID from JWT token
 * @param {string} token
 * @returns {string | undefined}
 */
export function get_user_id_from_jwt(token) {
    const ptr0 = passStringToWasm0(token, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.get_user_id_from_jwt(ptr0, len0);
    let v2;
    if (ret[0] !== 0) {
        v2 = getStringFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
    }
    return v2;
}

/**
 * Get device ID from JWT token
 * @param {string} token
 * @returns {string | undefined}
 */
export function get_device_id_from_jwt(token) {
    const ptr0 = passStringToWasm0(token, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.get_device_id_from_jwt(ptr0, len0);
    let v2;
    if (ret[0] !== 0) {
        v2 = getStringFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
    }
    return v2;
}

/**
 * Check if JWT token is expired
 * @param {string} token
 * @returns {boolean}
 */
export function is_jwt_expired(token) {
    const ptr0 = passStringToWasm0(token, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.is_jwt_expired(ptr0, len0);
    return ret !== 0;
}

/**
 * Infer thread type from message fields
 * @param {string} sender_id
 * @param {string} receiver_id
 * @param {string | null} [group_id]
 * @returns {string}
 */
export function infer_thread_type(sender_id, receiver_id, group_id) {
    let deferred4_0;
    let deferred4_1;
    try {
        const ptr0 = passStringToWasm0(sender_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(receiver_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        var ptr2 = isLikeNone(group_id) ? 0 : passStringToWasm0(group_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len2 = WASM_VECTOR_LEN;
        const ret = wasm.infer_thread_type(ptr0, len0, ptr1, len1, ptr2, len2);
        deferred4_0 = ret[0];
        deferred4_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred4_0, deferred4_1, 1);
    }
}

/**
 * Get canonical thread ID for a DM thread
 * @param {string} user1
 * @param {string} user2
 * @returns {string}
 */
export function get_dm_thread_id(user1, user2) {
    let deferred3_0;
    let deferred3_1;
    try {
        const ptr0 = passStringToWasm0(user1, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(user2, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.get_dm_thread_id(ptr0, len0, ptr1, len1);
        deferred3_0 = ret[0];
        deferred3_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred3_0, deferred3_1, 1);
    }
}

/**
 * @returns {number}
 */
export function max_community_members() {
    const ret = wasm.max_community_members();
    return ret >>> 0;
}

/**
 * @returns {number}
 */
export function max_community_groups() {
    const ret = wasm.max_community_groups();
    return ret >>> 0;
}

/**
 * @returns {number}
 */
export function max_community_name_length() {
    const ret = wasm.max_attachment_size_mb();
    return ret >>> 0;
}

/**
 * @returns {number}
 */
export function max_message_length() {
    const ret = wasm.max_message_length();
    return ret >>> 0;
}

/**
 * @returns {bigint}
 */
export function max_attachment_size_bytes() {
    const ret = wasm.max_attachment_size_bytes();
    return BigInt.asUintN(64, ret);
}

/**
 * @returns {number}
 */
export function max_attachment_size_mb() {
    const ret = wasm.max_attachment_size_mb();
    return ret >>> 0;
}

/**
 * @returns {number}
 */
export function min_username_length() {
    const ret = wasm.min_username_length();
    return ret >>> 0;
}

/**
 * @returns {number}
 */
export function max_username_length() {
    const ret = wasm.max_username_length();
    return ret >>> 0;
}

/**
 * @returns {string}
 */
export function username_regex_pattern() {
    let deferred1_0;
    let deferred1_1;
    try {
        const ret = wasm.username_regex_pattern();
        deferred1_0 = ret[0];
        deferred1_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
    }
}

/**
 * @returns {number}
 */
export function max_group_name_length() {
    const ret = wasm.max_attachment_size_mb();
    return ret >>> 0;
}

/**
 * @returns {number}
 */
export function max_group_members() {
    const ret = wasm.max_community_members();
    return ret >>> 0;
}

/**
 * @returns {number}
 */
export function pagination_page_size() {
    const ret = wasm.pagination_page_size();
    return ret >>> 0;
}

/**
 * @returns {number}
 */
export function query_result_limit() {
    const ret = wasm.max_attachment_size_mb();
    return ret >>> 0;
}

/**
 * @returns {number}
 */
export function log_buffer_capacity() {
    const ret = wasm.log_buffer_capacity();
    return ret >>> 0;
}

/**
 * @returns {bigint}
 */
export function network_timeout_ms() {
    const ret = wasm.network_timeout_ms();
    return BigInt.asUintN(64, ret);
}

/**
 * @returns {bigint}
 */
export function websocket_reconnect_delay_ms() {
    const ret = wasm.websocket_reconnect_delay_ms();
    return BigInt.asUintN(64, ret);
}

/**
 * @returns {bigint}
 */
export function image_cache_timeout_ms() {
    const ret = wasm.image_cache_timeout_ms();
    return BigInt.asUintN(64, ret);
}

/**
 * @returns {string}
 */
export function pref_jwt_token() {
    let deferred1_0;
    let deferred1_1;
    try {
        const ret = wasm.pref_jwt_token();
        deferred1_0 = ret[0];
        deferred1_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
    }
}

/**
 * @returns {string}
 */
export function pref_recovery_passphrase() {
    let deferred1_0;
    let deferred1_1;
    try {
        const ret = wasm.pref_recovery_passphrase();
        deferred1_0 = ret[0];
        deferred1_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
    }
}

/**
 * @returns {string}
 */
export function pref_contact_photos() {
    let deferred1_0;
    let deferred1_1;
    try {
        const ret = wasm.pref_contact_photos();
        deferred1_0 = ret[0];
        deferred1_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
    }
}

/**
 * Prepare a USER_ADDED message to send to a new group member.
 *
 * This function is called by the admin/owner who is adding the member.
 * It encrypts the group keys and metadata using NaCl box with the recipient's public key.
 *
 * # Arguments
 * * `thread_json` - JSON serialized Thread object
 * * `new_member_id` - User ID of the new member
 * * `new_member_public_key_base64` - New member's X25519 public key (Base64)
 * * `sender_id` - User ID of the admin sending this message
 * * `sender_secret_key_base64` - Admin's X25519 secret key (Base64)
 *
 * # Returns
 * A `WasmUserAddedPayload` ready to send via WebSocket
 * @param {string} thread_json
 * @param {string} new_member_id
 * @param {string} new_member_public_key_base64
 * @param {string} sender_id
 * @param {string} sender_secret_key_base64
 * @returns {WasmUserAddedPayload}
 */
export function prepare_user_added_message(thread_json, new_member_id, new_member_public_key_base64, sender_id, sender_secret_key_base64) {
    const ptr0 = passStringToWasm0(thread_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(new_member_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passStringToWasm0(new_member_public_key_base64, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passStringToWasm0(sender_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len3 = WASM_VECTOR_LEN;
    const ptr4 = passStringToWasm0(sender_secret_key_base64, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len4 = WASM_VECTOR_LEN;
    const ret = wasm.prepare_user_added_message(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return WasmUserAddedPayload.__wrap(ret[0]);
}

/**
 * Process a received USER_ADDED message to extract group keys and metadata.
 *
 * This function is called by the new member when they receive a USER_ADDED message.
 * It decrypts the group keys and metadata using NaCl box.
 *
 * # Arguments
 * * `payload_json` - JSON string of the received USER_ADDED payload
 * * `recipient_secret_key_base64` - New member's X25519 secret key (Base64)
 * * `sender_public_key_base64` - Admin's X25519 public key (Base64)
 *
 * # Returns
 * A JS object containing:
 * - `groupId`: string
 * - `groupKeys`: Record<number, string> (version -> key)
 * - `groupName`: string
 * - `groupDescription`: string | null
 * - `currentKeyVersion`: number
 * @param {string} payload_json
 * @param {string} recipient_secret_key_base64
 * @param {string} sender_public_key_base64
 * @returns {any}
 */
export function process_user_added_message(payload_json, recipient_secret_key_base64, sender_public_key_base64) {
    const ptr0 = passStringToWasm0(payload_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(recipient_secret_key_base64, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passStringToWasm0(sender_public_key_base64, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len2 = WASM_VECTOR_LEN;
    const ret = wasm.process_user_added_message(ptr0, len0, ptr1, len1, ptr2, len2);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

function wasm_bindgen__convert__closures_____invoke__h579a4fb2f5f72072(arg0, arg1, arg2) {
    wasm.wasm_bindgen__convert__closures_____invoke__h579a4fb2f5f72072(arg0, arg1, arg2);
}

function wasm_bindgen__convert__closures_____invoke__h4ae627bff36e25e6(arg0, arg1) {
    wasm.wasm_bindgen__convert__closures_____invoke__h4ae627bff36e25e6(arg0, arg1);
}

function wasm_bindgen__convert__closures_____invoke__hd4657407ae7052ff(arg0, arg1, arg2) {
    wasm.wasm_bindgen__convert__closures_____invoke__hd4657407ae7052ff(arg0, arg1, arg2);
}

function wasm_bindgen__convert__closures_____invoke__h3a711edbb81912f3(arg0, arg1, arg2, arg3) {
    wasm.wasm_bindgen__convert__closures_____invoke__h3a711edbb81912f3(arg0, arg1, arg2, arg3);
}

const __wbindgen_enum_BinaryType = ["blob", "arraybuffer"];

const WasmDecryptedMessageFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_wasmdecryptedmessage_free(ptr >>> 0, 1));
/**
 * Result of decrypting a message (for WASM)
 */
export class WasmDecryptedMessage {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(WasmDecryptedMessage.prototype);
        obj.__wbg_ptr = ptr;
        WasmDecryptedMessageFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        WasmDecryptedMessageFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_wasmdecryptedmessage_free(ptr, 0);
    }
    /**
     * @returns {string}
     */
    get content() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.__wbg_get_wasmdecryptedmessage_content(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {string} arg0
     */
    set content(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_wasmdecryptedmessage_content(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @returns {boolean}
     */
    get decrypted() {
        const ret = wasm.__wbg_get_wasmdecryptedmessage_decrypted(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @param {boolean} arg0
     */
    set decrypted(arg0) {
        wasm.__wbg_set_wasmdecryptedmessage_decrypted(this.__wbg_ptr, arg0);
    }
    /**
     * @returns {string | undefined}
     */
    get error() {
        const ret = wasm.__wbg_get_wasmdecryptedmessage_error(this.__wbg_ptr);
        let v1;
        if (ret[0] !== 0) {
            v1 = getStringFromWasm0(ret[0], ret[1]).slice();
            wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        }
        return v1;
    }
    /**
     * @param {string | null} [arg0]
     */
    set error(arg0) {
        var ptr0 = isLikeNone(arg0) ? 0 : passStringToWasm0(arg0, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_wasmdecryptedmessage_error(this.__wbg_ptr, ptr0, len0);
    }
}
if (Symbol.dispose) WasmDecryptedMessage.prototype[Symbol.dispose] = WasmDecryptedMessage.prototype.free;

const WasmEncryptedAttachmentFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_wasmencryptedattachment_free(ptr >>> 0, 1));
/**
 * Result of encrypting a file (for WASM)
 */
export class WasmEncryptedAttachment {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(WasmEncryptedAttachment.prototype);
        obj.__wbg_ptr = ptr;
        WasmEncryptedAttachmentFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        WasmEncryptedAttachmentFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_wasmencryptedattachment_free(ptr, 0);
    }
    /**
     * @returns {Uint8Array}
     */
    get data() {
        const ret = wasm.__wbg_get_wasmencryptedattachment_data(this.__wbg_ptr);
        var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
    /**
     * @param {Uint8Array} arg0
     */
    set data(arg0) {
        const ptr0 = passArray8ToWasm0(arg0, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_wasmencryptedattachment_data(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @returns {string}
     */
    get key_base64() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.__wbg_get_wasmencryptedattachment_key_base64(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {string} arg0
     */
    set key_base64(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_wasmencryptedattachment_key_base64(this.__wbg_ptr, ptr0, len0);
    }
}
if (Symbol.dispose) WasmEncryptedAttachment.prototype[Symbol.dispose] = WasmEncryptedAttachment.prototype.free;

const WasmEncryptedMessageFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_wasmencryptedmessage_free(ptr >>> 0, 1));
/**
 * Result of encrypting a message (for WASM)
 */
export class WasmEncryptedMessage {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(WasmEncryptedMessage.prototype);
        obj.__wbg_ptr = ptr;
        WasmEncryptedMessageFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        WasmEncryptedMessageFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_wasmencryptedmessage_free(ptr, 0);
    }
    /**
     * @returns {string}
     */
    get encrypted_content() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.__wbg_get_wasmencryptedmessage_encrypted_content(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {string} arg0
     */
    set encrypted_content(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_wasmencryptedmessage_encrypted_content(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @returns {string}
     */
    get nonce() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.__wbg_get_wasmencryptedmessage_nonce(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {string} arg0
     */
    set nonce(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_wasmencryptedmessage_nonce(this.__wbg_ptr, ptr0, len0);
    }
}
if (Symbol.dispose) WasmEncryptedMessage.prototype[Symbol.dispose] = WasmEncryptedMessage.prototype.free;

const WasmHiLoCodesFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_wasmhilocodes_free(ptr >>> 0, 1));
/**
 * HiLo codes for WASM
 */
export class WasmHiLoCodes {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(WasmHiLoCodes.prototype);
        obj.__wbg_ptr = ptr;
        WasmHiLoCodesFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        WasmHiLoCodesFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_wasmhilocodes_free(ptr, 0);
    }
    /**
     * Create new empty codes
     */
    constructor() {
        const ret = wasm.wasmhilocodes_new();
        this.__wbg_ptr = ret >>> 0;
        WasmHiLoCodesFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * Check if codes are configured
     * @returns {boolean}
     */
    is_configured() {
        const ret = wasm.wasmhilocodes_is_configured(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * Set codes from plaintext (will be hashed)
     * @param {string} hi
     * @param {string} lo
     * @param {string | null} [destroy]
     */
    set_codes(hi, lo, destroy) {
        const ptr0 = passStringToWasm0(hi, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(lo, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        var ptr2 = isLikeNone(destroy) ? 0 : passStringToWasm0(destroy, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len2 = WASM_VECTOR_LEN;
        const ret = wasm.wasmhilocodes_set_codes(this.__wbg_ptr, ptr0, len0, ptr1, len1, ptr2, len2);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * Verify a code and return which environment it unlocks ("hi" or "lo")
     * Returns error if code is invalid or triggers destroy
     * @param {string} code
     * @returns {string}
     */
    verify_code(code) {
        let deferred3_0;
        let deferred3_1;
        try {
            const ptr0 = passStringToWasm0(code, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            const ret = wasm.wasmhilocodes_verify_code(this.__wbg_ptr, ptr0, len0);
            var ptr2 = ret[0];
            var len2 = ret[1];
            if (ret[3]) {
                ptr2 = 0; len2 = 0;
                throw takeFromExternrefTable0(ret[2]);
            }
            deferred3_0 = ptr2;
            deferred3_1 = len2;
            return getStringFromWasm0(ptr2, len2);
        } finally {
            wasm.__wbindgen_free(deferred3_0, deferred3_1, 1);
        }
    }
    /**
     * Clear all codes
     */
    clear() {
        wasm.wasmhilocodes_clear(this.__wbg_ptr);
    }
    /**
     * Serialize to JSON for storage
     * @returns {string}
     */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const ret = wasm.wasmhilocodes_to_json(this.__wbg_ptr);
            var ptr1 = ret[0];
            var len1 = ret[1];
            if (ret[3]) {
                ptr1 = 0; len1 = 0;
                throw takeFromExternrefTable0(ret[2]);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
     * Deserialize from JSON
     * @param {string} json
     * @returns {WasmHiLoCodes}
     */
    static from_json(json) {
        const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.wasmhilocodes_from_json(ptr0, len0);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return WasmHiLoCodes.__wrap(ret[0]);
    }
}
if (Symbol.dispose) WasmHiLoCodes.prototype[Symbol.dispose] = WasmHiLoCodes.prototype.free;

const WasmHiLoStateFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_wasmhilostate_free(ptr >>> 0, 1));
/**
 * HiLo state manager for WASM
 */
export class WasmHiLoState {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(WasmHiLoState.prototype);
        obj.__wbg_ptr = ptr;
        WasmHiLoStateFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        WasmHiLoStateFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_wasmhilostate_free(ptr, 0);
    }
    /**
     * Create new state
     */
    constructor() {
        const ret = wasm.wasmhilostate_new();
        this.__wbg_ptr = ret >>> 0;
        WasmHiLoStateFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * Get current environment ("hi" or "lo")
     * @returns {string}
     */
    environment() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.wasmhilostate_environment(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * Check if screen is locked
     * @returns {boolean}
     */
    is_locked() {
        const ret = wasm.wasmhilostate_is_locked(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * Check if codes are configured
     * @returns {boolean}
     */
    is_configured() {
        const ret = wasm.wasmhilostate_is_configured(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * Check if lock screen should be shown
     * @returns {boolean}
     */
    should_lock() {
        const ret = wasm.wasmhilostate_should_lock(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * Lock the screen
     */
    lock() {
        wasm.wasmhilostate_lock(this.__wbg_ptr);
    }
    /**
     * Unlock with a code, returns the environment ("hi" or "lo")
     * @param {string} code
     * @returns {string}
     */
    unlock(code) {
        let deferred3_0;
        let deferred3_1;
        try {
            const ptr0 = passStringToWasm0(code, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            const ret = wasm.wasmhilostate_unlock(this.__wbg_ptr, ptr0, len0);
            var ptr2 = ret[0];
            var len2 = ret[1];
            if (ret[3]) {
                ptr2 = 0; len2 = 0;
                throw takeFromExternrefTable0(ret[2]);
            }
            deferred3_0 = ptr2;
            deferred3_1 = len2;
            return getStringFromWasm0(ptr2, len2);
        } finally {
            wasm.__wbindgen_free(deferred3_0, deferred3_1, 1);
        }
    }
    /**
     * Set the current environment directly ("hi" or "lo")
     * @param {string} env
     */
    set_environment(env) {
        const ptr0 = passStringToWasm0(env, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.wasmhilostate_set_environment(this.__wbg_ptr, ptr0, len0);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * Configure codes
     * @param {string} hi
     * @param {string} lo
     * @param {string | null} [destroy]
     */
    set_codes(hi, lo, destroy) {
        const ptr0 = passStringToWasm0(hi, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(lo, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        var ptr2 = isLikeNone(destroy) ? 0 : passStringToWasm0(destroy, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len2 = WASM_VECTOR_LEN;
        const ret = wasm.wasmhilostate_set_codes(this.__wbg_ptr, ptr0, len0, ptr1, len1, ptr2, len2);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * Serialize to JSON for storage
     * @returns {string}
     */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const ret = wasm.wasmhilostate_to_json(this.__wbg_ptr);
            var ptr1 = ret[0];
            var len1 = ret[1];
            if (ret[3]) {
                ptr1 = 0; len1 = 0;
                throw takeFromExternrefTable0(ret[2]);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
     * Deserialize from JSON
     * @param {string} json
     * @returns {WasmHiLoState}
     */
    static from_json(json) {
        const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.wasmhilostate_from_json(ptr0, len0);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return WasmHiLoState.__wrap(ret[0]);
    }
}
if (Symbol.dispose) WasmHiLoState.prototype[Symbol.dispose] = WasmHiLoState.prototype.free;

const WasmKeyPairFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_wasmkeypair_free(ptr >>> 0, 1));

export class WasmKeyPair {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(WasmKeyPair.prototype);
        obj.__wbg_ptr = ptr;
        WasmKeyPairFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        WasmKeyPairFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_wasmkeypair_free(ptr, 0);
    }
    /**
     * @returns {Uint8Array}
     */
    get public_key() {
        const ret = wasm.__wbg_get_wasmkeypair_public_key(this.__wbg_ptr);
        var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
    /**
     * @param {Uint8Array} arg0
     */
    set public_key(arg0) {
        const ptr0 = passArray8ToWasm0(arg0, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_wasmkeypair_public_key(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @returns {Uint8Array}
     */
    get secret_key() {
        const ret = wasm.__wbg_get_wasmkeypair_secret_key(this.__wbg_ptr);
        var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
    /**
     * @param {Uint8Array} arg0
     */
    set secret_key(arg0) {
        const ptr0 = passArray8ToWasm0(arg0, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_wasmkeypair_secret_key(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @returns {string}
     */
    public_key_base64() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.wasmkeypair_public_key_base64(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    secret_key_base64() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.wasmkeypair_secret_key_base64(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
}
if (Symbol.dispose) WasmKeyPair.prototype[Symbol.dispose] = WasmKeyPair.prototype.free;

const WasmMlKemKeyPairFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_wasmmlkemkeypair_free(ptr >>> 0, 1));

export class WasmMlKemKeyPair {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(WasmMlKemKeyPair.prototype);
        obj.__wbg_ptr = ptr;
        WasmMlKemKeyPairFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        WasmMlKemKeyPairFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_wasmmlkemkeypair_free(ptr, 0);
    }
    /**
     * @returns {Uint8Array}
     */
    get public_key() {
        const ret = wasm.__wbg_get_wasmmlkemkeypair_public_key(this.__wbg_ptr);
        var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
    /**
     * @param {Uint8Array} arg0
     */
    set public_key(arg0) {
        const ptr0 = passArray8ToWasm0(arg0, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_wasmmlkemkeypair_public_key(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @returns {Uint8Array}
     */
    get secret_key() {
        const ret = wasm.__wbg_get_wasmmlkemkeypair_secret_key(this.__wbg_ptr);
        var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
    /**
     * @param {Uint8Array} arg0
     */
    set secret_key(arg0) {
        const ptr0 = passArray8ToWasm0(arg0, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_wasmmlkemkeypair_secret_key(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @returns {string}
     */
    public_key_base64() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.wasmmlkemkeypair_public_key_base64(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    secret_key_base64() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.wasmmlkemkeypair_secret_key_base64(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
}
if (Symbol.dispose) WasmMlKemKeyPair.prototype[Symbol.dispose] = WasmMlKemKeyPair.prototype.free;

const WasmPreparedGroupMessageFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_wasmpreparedgroupmessage_free(ptr >>> 0, 1));
/**
 * Prepared group message result for WASM
 */
export class WasmPreparedGroupMessage {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(WasmPreparedGroupMessage.prototype);
        obj.__wbg_ptr = ptr;
        WasmPreparedGroupMessageFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        WasmPreparedGroupMessageFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_wasmpreparedgroupmessage_free(ptr, 0);
    }
    /**
     * @returns {string}
     */
    get id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.__wbg_get_wasmpreparedgroupmessage_id(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {string} arg0
     */
    set id(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_wasmpreparedgroupmessage_id(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @returns {string}
     */
    get group_id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.__wbg_get_wasmpreparedgroupmessage_group_id(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {string} arg0
     */
    set group_id(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_wasmpreparedgroupmessage_group_id(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @returns {string}
     */
    get encrypted_content() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.__wbg_get_wasmpreparedgroupmessage_encrypted_content(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {string} arg0
     */
    set encrypted_content(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_wasmpreparedgroupmessage_encrypted_content(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @returns {string}
     */
    get nonce() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.__wbg_get_wasmpreparedgroupmessage_nonce(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {string} arg0
     */
    set nonce(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_wasmpreparedgroupmessage_nonce(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @returns {string}
     */
    get content_type() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.__wbg_get_wasmpreparedgroupmessage_content_type(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {string} arg0
     */
    set content_type(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_wasmpreparedgroupmessage_content_type(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * Key version used to encrypt this message (for key rotation support)
     * @returns {number}
     */
    get key_version() {
        const ret = wasm.__wbg_get_wasmpreparedgroupmessage_key_version(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * Key version used to encrypt this message (for key rotation support)
     * @param {number} arg0
     */
    set key_version(arg0) {
        wasm.__wbg_set_wasmpreparedgroupmessage_key_version(this.__wbg_ptr, arg0);
    }
}
if (Symbol.dispose) WasmPreparedGroupMessage.prototype[Symbol.dispose] = WasmPreparedGroupMessage.prototype.free;

const WasmPreparedMessageFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_wasmpreparedmessage_free(ptr >>> 0, 1));
/**
 * Prepared message result for WASM
 * Contains all fields needed to send the message over WebSocket
 */
export class WasmPreparedMessage {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(WasmPreparedMessage.prototype);
        obj.__wbg_ptr = ptr;
        WasmPreparedMessageFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        WasmPreparedMessageFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_wasmpreparedmessage_free(ptr, 0);
    }
    /**
     * @returns {string}
     */
    get id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.__wbg_get_wasmpreparedmessage_id(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {string} arg0
     */
    set id(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_wasmpreparedmessage_id(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @returns {string}
     */
    get receiver_id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.__wbg_get_wasmpreparedmessage_receiver_id(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {string} arg0
     */
    set receiver_id(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_wasmpreparedmessage_receiver_id(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @returns {string | undefined}
     */
    get sender_key_id() {
        const ret = wasm.__wbg_get_wasmpreparedmessage_sender_key_id(this.__wbg_ptr);
        let v1;
        if (ret[0] !== 0) {
            v1 = getStringFromWasm0(ret[0], ret[1]).slice();
            wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        }
        return v1;
    }
    /**
     * @param {string | null} [arg0]
     */
    set sender_key_id(arg0) {
        var ptr0 = isLikeNone(arg0) ? 0 : passStringToWasm0(arg0, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_wasmpreparedmessage_sender_key_id(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @returns {string | undefined}
     */
    get target_device_id() {
        const ret = wasm.__wbg_get_wasmpreparedmessage_target_device_id(this.__wbg_ptr);
        let v1;
        if (ret[0] !== 0) {
            v1 = getStringFromWasm0(ret[0], ret[1]).slice();
            wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        }
        return v1;
    }
    /**
     * @param {string | null} [arg0]
     */
    set target_device_id(arg0) {
        var ptr0 = isLikeNone(arg0) ? 0 : passStringToWasm0(arg0, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_wasmpreparedmessage_target_device_id(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @returns {string}
     */
    get encrypted_content() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.__wbg_get_wasmpreparedmessage_encrypted_content(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {string} arg0
     */
    set encrypted_content(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_wasmpreparedmessage_encrypted_content(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @returns {string}
     */
    get nonce() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.__wbg_get_wasmpreparedmessage_nonce(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {string} arg0
     */
    set nonce(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_wasmpreparedmessage_nonce(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @returns {string}
     */
    get enc_version() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.__wbg_get_wasmpreparedmessage_enc_version(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {string} arg0
     */
    set enc_version(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_wasmpreparedmessage_enc_version(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @returns {string | undefined}
     */
    get ml_kem_ciphertext() {
        const ret = wasm.__wbg_get_wasmpreparedmessage_ml_kem_ciphertext(this.__wbg_ptr);
        let v1;
        if (ret[0] !== 0) {
            v1 = getStringFromWasm0(ret[0], ret[1]).slice();
            wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        }
        return v1;
    }
    /**
     * @param {string | null} [arg0]
     */
    set ml_kem_ciphertext(arg0) {
        var ptr0 = isLikeNone(arg0) ? 0 : passStringToWasm0(arg0, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_wasmpreparedmessage_ml_kem_ciphertext(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @returns {string}
     */
    get thread_key() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.__wbg_get_wasmpreparedmessage_thread_key(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {string} arg0
     */
    set thread_key(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_wasmpreparedmessage_thread_key(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @returns {string}
     */
    get content_type() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.__wbg_get_wasmpreparedmessage_content_type(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {string} arg0
     */
    set content_type(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_wasmpreparedmessage_content_type(this.__wbg_ptr, ptr0, len0);
    }
}
if (Symbol.dispose) WasmPreparedMessage.prototype[Symbol.dispose] = WasmPreparedMessage.prototype.free;

const WasmUserAddedPayloadFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_wasmuseraddedpayload_free(ptr >>> 0, 1));
/**
 * Result of preparing a USER_ADDED message
 */
export class WasmUserAddedPayload {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(WasmUserAddedPayload.prototype);
        obj.__wbg_ptr = ptr;
        WasmUserAddedPayloadFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        WasmUserAddedPayloadFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_wasmuseraddedpayload_free(ptr, 0);
    }
    /**
     * @returns {string}
     */
    get id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.__wbg_get_wasmuseraddedpayload_id(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {string} arg0
     */
    set id(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_wasmuseraddedpayload_id(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @returns {string}
     */
    get group_id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.__wbg_get_wasmuseraddedpayload_group_id(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {string} arg0
     */
    set group_id(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_wasmuseraddedpayload_group_id(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @returns {string}
     */
    get receiver_id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.__wbg_get_wasmuseraddedpayload_receiver_id(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {string} arg0
     */
    set receiver_id(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_wasmuseraddedpayload_receiver_id(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @returns {string}
     */
    get sender_id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.__wbg_get_wasmuseraddedpayload_sender_id(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {string} arg0
     */
    set sender_id(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_wasmuseraddedpayload_sender_id(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @returns {string}
     */
    get encrypted_keys() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.__wbg_get_wasmuseraddedpayload_encrypted_keys(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {string} arg0
     */
    set encrypted_keys(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_wasmuseraddedpayload_encrypted_keys(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @returns {string}
     */
    get encrypted_group_data() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.__wbg_get_wasmuseraddedpayload_encrypted_group_data(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {string} arg0
     */
    set encrypted_group_data(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_wasmuseraddedpayload_encrypted_group_data(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @returns {string}
     */
    get nonce() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.__wbg_get_wasmuseraddedpayload_nonce(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {string} arg0
     */
    set nonce(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_wasmuseraddedpayload_nonce(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @returns {bigint}
     */
    get timestamp() {
        const ret = wasm.__wbg_get_wasmuseraddedpayload_timestamp(this.__wbg_ptr);
        return ret;
    }
    /**
     * @param {bigint} arg0
     */
    set timestamp(arg0) {
        wasm.__wbg_set_wasmuseraddedpayload_timestamp(this.__wbg_ptr, arg0);
    }
}
if (Symbol.dispose) WasmUserAddedPayload.prototype[Symbol.dispose] = WasmUserAddedPayload.prototype.free;

const EXPECTED_RESPONSE_TYPES = new Set(['basic', 'cors', 'default']);

async function __wbg_load(module, imports) {
    if (typeof Response === 'function' && module instanceof Response) {
        if (typeof WebAssembly.instantiateStreaming === 'function') {
            try {
                return await WebAssembly.instantiateStreaming(module, imports);

            } catch (e) {
                const validResponse = module.ok && EXPECTED_RESPONSE_TYPES.has(module.type);

                if (validResponse && module.headers.get('Content-Type') !== 'application/wasm') {
                    console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve Wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n", e);

                } else {
                    throw e;
                }
            }
        }

        const bytes = await module.arrayBuffer();
        return await WebAssembly.instantiate(bytes, imports);

    } else {
        const instance = await WebAssembly.instantiate(module, imports);

        if (instance instanceof WebAssembly.Instance) {
            return { instance, module };

        } else {
            return instance;
        }
    }
}

function __wbg_get_imports() {
    const imports = {};
    imports.wbg = {};
    imports.wbg.__wbg_Error_e83987f665cf5504 = function(arg0, arg1) {
        const ret = Error(getStringFromWasm0(arg0, arg1));
        return ret;
    };
    imports.wbg.__wbg_Number_bb48ca12f395cd08 = function(arg0) {
        const ret = Number(arg0);
        return ret;
    };
    imports.wbg.__wbg_String_8f0eb39a4a4c2f66 = function(arg0, arg1) {
        const ret = String(arg1);
        const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
        getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
    };
    imports.wbg.__wbg___wbindgen_bigint_get_as_i64_f3ebc5a755000afd = function(arg0, arg1) {
        const v = arg1;
        const ret = typeof(v) === 'bigint' ? v : undefined;
        getDataViewMemory0().setBigInt64(arg0 + 8 * 1, isLikeNone(ret) ? BigInt(0) : ret, true);
        getDataViewMemory0().setInt32(arg0 + 4 * 0, !isLikeNone(ret), true);
    };
    imports.wbg.__wbg___wbindgen_boolean_get_6d5a1ee65bab5f68 = function(arg0) {
        const v = arg0;
        const ret = typeof(v) === 'boolean' ? v : undefined;
        return isLikeNone(ret) ? 0xFFFFFF : ret ? 1 : 0;
    };
    imports.wbg.__wbg___wbindgen_debug_string_df47ffb5e35e6763 = function(arg0, arg1) {
        const ret = debugString(arg1);
        const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
        getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
    };
    imports.wbg.__wbg___wbindgen_in_bb933bd9e1b3bc0f = function(arg0, arg1) {
        const ret = arg0 in arg1;
        return ret;
    };
    imports.wbg.__wbg___wbindgen_is_bigint_cb320707dcd35f0b = function(arg0) {
        const ret = typeof(arg0) === 'bigint';
        return ret;
    };
    imports.wbg.__wbg___wbindgen_is_function_ee8a6c5833c90377 = function(arg0) {
        const ret = typeof(arg0) === 'function';
        return ret;
    };
    imports.wbg.__wbg___wbindgen_is_null_5e69f72e906cc57c = function(arg0) {
        const ret = arg0 === null;
        return ret;
    };
    imports.wbg.__wbg___wbindgen_is_object_c818261d21f283a4 = function(arg0) {
        const val = arg0;
        const ret = typeof(val) === 'object' && val !== null;
        return ret;
    };
    imports.wbg.__wbg___wbindgen_is_string_fbb76cb2940daafd = function(arg0) {
        const ret = typeof(arg0) === 'string';
        return ret;
    };
    imports.wbg.__wbg___wbindgen_is_undefined_2d472862bd29a478 = function(arg0) {
        const ret = arg0 === undefined;
        return ret;
    };
    imports.wbg.__wbg___wbindgen_jsval_eq_6b13ab83478b1c50 = function(arg0, arg1) {
        const ret = arg0 === arg1;
        return ret;
    };
    imports.wbg.__wbg___wbindgen_jsval_loose_eq_b664b38a2f582147 = function(arg0, arg1) {
        const ret = arg0 == arg1;
        return ret;
    };
    imports.wbg.__wbg___wbindgen_number_get_a20bf9b85341449d = function(arg0, arg1) {
        const obj = arg1;
        const ret = typeof(obj) === 'number' ? obj : undefined;
        getDataViewMemory0().setFloat64(arg0 + 8 * 1, isLikeNone(ret) ? 0 : ret, true);
        getDataViewMemory0().setInt32(arg0 + 4 * 0, !isLikeNone(ret), true);
    };
    imports.wbg.__wbg___wbindgen_string_get_e4f06c90489ad01b = function(arg0, arg1) {
        const obj = arg1;
        const ret = typeof(obj) === 'string' ? obj : undefined;
        var ptr1 = isLikeNone(ret) ? 0 : passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len1 = WASM_VECTOR_LEN;
        getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
        getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
    };
    imports.wbg.__wbg___wbindgen_throw_b855445ff6a94295 = function(arg0, arg1) {
        throw new Error(getStringFromWasm0(arg0, arg1));
    };
    imports.wbg.__wbg__wbg_cb_unref_2454a539ea5790d9 = function(arg0) {
        arg0._wbg_cb_unref();
    };
    imports.wbg.__wbg_addEventListener_534b9f715f44517f = function() { return handleError(function (arg0, arg1, arg2, arg3, arg4) {
        arg0.addEventListener(getStringFromWasm0(arg1, arg2), arg3, arg4);
    }, arguments) };
    imports.wbg.__wbg_addEventListener_7a418931447b2eae = function() { return handleError(function (arg0, arg1, arg2, arg3) {
        arg0.addEventListener(getStringFromWasm0(arg1, arg2), arg3);
    }, arguments) };
    imports.wbg.__wbg_call_525440f72fbfc0ea = function() { return handleError(function (arg0, arg1, arg2) {
        const ret = arg0.call(arg1, arg2);
        return ret;
    }, arguments) };
    imports.wbg.__wbg_call_e762c39fa8ea36bf = function() { return handleError(function (arg0, arg1) {
        const ret = arg0.call(arg1);
        return ret;
    }, arguments) };
    imports.wbg.__wbg_close_885e277edf06b3fa = function() { return handleError(function (arg0) {
        arg0.close();
    }, arguments) };
    imports.wbg.__wbg_code_20d453b11b200026 = function(arg0) {
        const ret = arg0.code;
        return ret;
    };
    imports.wbg.__wbg_crypto_574e78ad8b13b65f = function(arg0) {
        const ret = arg0.crypto;
        return ret;
    };
    imports.wbg.__wbg_data_ee4306d069f24f2d = function(arg0) {
        const ret = arg0.data;
        return ret;
    };
    imports.wbg.__wbg_dispatchEvent_6eaea6d4f99ff3bf = function() { return handleError(function (arg0, arg1) {
        const ret = arg0.dispatchEvent(arg1);
        return ret;
    }, arguments) };
    imports.wbg.__wbg_done_2042aa2670fb1db1 = function(arg0) {
        const ret = arg0.done;
        return ret;
    };
    imports.wbg.__wbg_entries_e171b586f8f6bdbf = function(arg0) {
        const ret = Object.entries(arg0);
        return ret;
    };
    imports.wbg.__wbg_error_7534b8e9a36f1ab4 = function(arg0, arg1) {
        let deferred0_0;
        let deferred0_1;
        try {
            deferred0_0 = arg0;
            deferred0_1 = arg1;
            console.error(getStringFromWasm0(arg0, arg1));
        } finally {
            wasm.__wbindgen_free(deferred0_0, deferred0_1, 1);
        }
    };
    imports.wbg.__wbg_fetch_0c645bcbfc592368 = function(arg0, arg1) {
        const ret = arg0.fetch(arg1);
        return ret;
    };
    imports.wbg.__wbg_fetch_f8ba0e29a9d6de0d = function(arg0, arg1) {
        const ret = arg0.fetch(arg1);
        return ret;
    };
    imports.wbg.__wbg_getRandomValues_38a1ff1ea09f6cc7 = function() { return handleError(function (arg0, arg1) {
        globalThis.crypto.getRandomValues(getArrayU8FromWasm0(arg0, arg1));
    }, arguments) };
    imports.wbg.__wbg_getRandomValues_b8f5dbd5f3995a9e = function() { return handleError(function (arg0, arg1) {
        arg0.getRandomValues(arg1);
    }, arguments) };
    imports.wbg.__wbg_getRandomValues_e9de607763a970bd = function() { return handleError(function (arg0, arg1) {
        globalThis.crypto.getRandomValues(getArrayU8FromWasm0(arg0, arg1));
    }, arguments) };
    imports.wbg.__wbg_get_7bed016f185add81 = function(arg0, arg1) {
        const ret = arg0[arg1 >>> 0];
        return ret;
    };
    imports.wbg.__wbg_get_efcb449f58ec27c2 = function() { return handleError(function (arg0, arg1) {
        const ret = Reflect.get(arg0, arg1);
        return ret;
    }, arguments) };
    imports.wbg.__wbg_get_with_ref_key_1dc361bd10053bfe = function(arg0, arg1) {
        const ret = arg0[arg1];
        return ret;
    };
    imports.wbg.__wbg_instanceof_ArrayBuffer_70beb1189ca63b38 = function(arg0) {
        let result;
        try {
            result = arg0 instanceof ArrayBuffer;
        } catch (_) {
            result = false;
        }
        const ret = result;
        return ret;
    };
    imports.wbg.__wbg_instanceof_Error_a944ec10920129e2 = function(arg0) {
        let result;
        try {
            result = arg0 instanceof Error;
        } catch (_) {
            result = false;
        }
        const ret = result;
        return ret;
    };
    imports.wbg.__wbg_instanceof_Response_f4f3e87e07f3135c = function(arg0) {
        let result;
        try {
            result = arg0 instanceof Response;
        } catch (_) {
            result = false;
        }
        const ret = result;
        return ret;
    };
    imports.wbg.__wbg_instanceof_Uint8Array_20c8e73002f7af98 = function(arg0) {
        let result;
        try {
            result = arg0 instanceof Uint8Array;
        } catch (_) {
            result = false;
        }
        const ret = result;
        return ret;
    };
    imports.wbg.__wbg_instanceof_Window_4846dbb3de56c84c = function(arg0) {
        let result;
        try {
            result = arg0 instanceof Window;
        } catch (_) {
            result = false;
        }
        const ret = result;
        return ret;
    };
    imports.wbg.__wbg_instanceof_WorkerGlobalScope_e31f49b6d33fcadd = function(arg0) {
        let result;
        try {
            result = arg0 instanceof WorkerGlobalScope;
        } catch (_) {
            result = false;
        }
        const ret = result;
        return ret;
    };
    imports.wbg.__wbg_isArray_96e0af9891d0945d = function(arg0) {
        const ret = Array.isArray(arg0);
        return ret;
    };
    imports.wbg.__wbg_isSafeInteger_d216eda7911dde36 = function(arg0) {
        const ret = Number.isSafeInteger(arg0);
        return ret;
    };
    imports.wbg.__wbg_iterator_e5822695327a3c39 = function() {
        const ret = Symbol.iterator;
        return ret;
    };
    imports.wbg.__wbg_length_69bca3cb64fc8748 = function(arg0) {
        const ret = arg0.length;
        return ret;
    };
    imports.wbg.__wbg_length_cdd215e10d9dd507 = function(arg0) {
        const ret = arg0.length;
        return ret;
    };
    imports.wbg.__wbg_log_8cec76766b8c0e33 = function(arg0) {
        console.log(arg0);
    };
    imports.wbg.__wbg_message_1ee258909d7264fd = function(arg0) {
        const ret = arg0.message;
        return ret;
    };
    imports.wbg.__wbg_msCrypto_a61aeb35a24c1329 = function(arg0) {
        const ret = arg0.msCrypto;
        return ret;
    };
    imports.wbg.__wbg_name_4810447ab1aad468 = function(arg0) {
        const ret = arg0.name;
        return ret;
    };
    imports.wbg.__wbg_new_1acc0b6eea89d040 = function() {
        const ret = new Object();
        return ret;
    };
    imports.wbg.__wbg_new_3c3d849046688a66 = function(arg0, arg1) {
        try {
            var state0 = {a: arg0, b: arg1};
            var cb0 = (arg0, arg1) => {
                const a = state0.a;
                state0.a = 0;
                try {
                    return wasm_bindgen__convert__closures_____invoke__h3a711edbb81912f3(a, state0.b, arg0, arg1);
                } finally {
                    state0.a = a;
                }
            };
            const ret = new Promise(cb0);
            return ret;
        } finally {
            state0.a = state0.b = 0;
        }
    };
    imports.wbg.__wbg_new_5a79be3ab53b8aa5 = function(arg0) {
        const ret = new Uint8Array(arg0);
        return ret;
    };
    imports.wbg.__wbg_new_68651c719dcda04e = function() {
        const ret = new Map();
        return ret;
    };
    imports.wbg.__wbg_new_81afc06ccd3bd6a5 = function() { return handleError(function (arg0, arg1) {
        const ret = new URL(getStringFromWasm0(arg0, arg1));
        return ret;
    }, arguments) };
    imports.wbg.__wbg_new_881c4fe631eee9ad = function() { return handleError(function (arg0, arg1) {
        const ret = new WebSocket(getStringFromWasm0(arg0, arg1));
        return ret;
    }, arguments) };
    imports.wbg.__wbg_new_8a6f238a6ece86ea = function() {
        const ret = new Error();
        return ret;
    };
    imports.wbg.__wbg_new_9edf9838a2def39c = function() { return handleError(function () {
        const ret = new Headers();
        return ret;
    }, arguments) };
    imports.wbg.__wbg_new_a7442b4b19c1a356 = function(arg0, arg1) {
        const ret = new Error(getStringFromWasm0(arg0, arg1));
        return ret;
    };
    imports.wbg.__wbg_new_bf96d2ae6ae942b8 = function() { return handleError(function () {
        const ret = new URLSearchParams();
        return ret;
    }, arguments) };
    imports.wbg.__wbg_new_e17d9f43105b08be = function() {
        const ret = new Array();
        return ret;
    };
    imports.wbg.__wbg_new_from_slice_92f4d78ca282a2d2 = function(arg0, arg1) {
        const ret = new Uint8Array(getArrayU8FromWasm0(arg0, arg1));
        return ret;
    };
    imports.wbg.__wbg_new_no_args_ee98eee5275000a4 = function(arg0, arg1) {
        const ret = new Function(getStringFromWasm0(arg0, arg1));
        return ret;
    };
    imports.wbg.__wbg_new_with_event_init_dict_9d484fa64a7e1e62 = function() { return handleError(function (arg0, arg1, arg2) {
        const ret = new CloseEvent(getStringFromWasm0(arg0, arg1), arg2);
        return ret;
    }, arguments) };
    imports.wbg.__wbg_new_with_length_01aa0dc35aa13543 = function(arg0) {
        const ret = new Uint8Array(arg0 >>> 0);
        return ret;
    };
    imports.wbg.__wbg_new_with_str_and_init_0ae7728b6ec367b1 = function() { return handleError(function (arg0, arg1, arg2) {
        const ret = new Request(getStringFromWasm0(arg0, arg1), arg2);
        return ret;
    }, arguments) };
    imports.wbg.__wbg_new_with_str_eb321d3099689bba = function() { return handleError(function (arg0, arg1) {
        const ret = new Request(getStringFromWasm0(arg0, arg1));
        return ret;
    }, arguments) };
    imports.wbg.__wbg_new_with_str_sequence_57a88eb77393f23f = function() { return handleError(function (arg0, arg1, arg2) {
        const ret = new WebSocket(getStringFromWasm0(arg0, arg1), arg2);
        return ret;
    }, arguments) };
    imports.wbg.__wbg_next_020810e0ae8ebcb0 = function() { return handleError(function (arg0) {
        const ret = arg0.next();
        return ret;
    }, arguments) };
    imports.wbg.__wbg_next_2c826fe5dfec6b6a = function(arg0) {
        const ret = arg0.next;
        return ret;
    };
    imports.wbg.__wbg_node_905d3e251edff8a2 = function(arg0) {
        const ret = arg0.node;
        return ret;
    };
    imports.wbg.__wbg_now_793306c526e2e3b6 = function() {
        const ret = Date.now();
        return ret;
    };
    imports.wbg.__wbg_ok_5749966cb2b8535e = function(arg0) {
        const ret = arg0.ok;
        return ret;
    };
    imports.wbg.__wbg_parse_2a704d6b78abb2b8 = function() { return handleError(function (arg0, arg1) {
        const ret = JSON.parse(getStringFromWasm0(arg0, arg1));
        return ret;
    }, arguments) };
    imports.wbg.__wbg_process_dc0fbacc7c1c06f7 = function(arg0) {
        const ret = arg0.process;
        return ret;
    };
    imports.wbg.__wbg_prototypesetcall_2a6620b6922694b2 = function(arg0, arg1, arg2) {
        Uint8Array.prototype.set.call(getArrayU8FromWasm0(arg0, arg1), arg2);
    };
    imports.wbg.__wbg_push_df81a39d04db858c = function(arg0, arg1) {
        const ret = arg0.push(arg1);
        return ret;
    };
    imports.wbg.__wbg_queueMicrotask_34d692c25c47d05b = function(arg0) {
        const ret = arg0.queueMicrotask;
        return ret;
    };
    imports.wbg.__wbg_queueMicrotask_9d76cacb20c84d58 = function(arg0) {
        queueMicrotask(arg0);
    };
    imports.wbg.__wbg_randomFillSync_ac0988aba3254290 = function() { return handleError(function (arg0, arg1) {
        arg0.randomFillSync(arg1);
    }, arguments) };
    imports.wbg.__wbg_readyState_97984f126080aeda = function(arg0) {
        const ret = arg0.readyState;
        return ret;
    };
    imports.wbg.__wbg_reason_1cced37e3a93763e = function(arg0, arg1) {
        const ret = arg1.reason;
        const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
        getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
    };
    imports.wbg.__wbg_removeEventListener_aa21ef619e743518 = function() { return handleError(function (arg0, arg1, arg2, arg3) {
        arg0.removeEventListener(getStringFromWasm0(arg1, arg2), arg3);
    }, arguments) };
    imports.wbg.__wbg_require_60cc747a6bc5215a = function() { return handleError(function () {
        const ret = module.require;
        return ret;
    }, arguments) };
    imports.wbg.__wbg_resolve_caf97c30b83f7053 = function(arg0) {
        const ret = Promise.resolve(arg0);
        return ret;
    };
    imports.wbg.__wbg_search_3dfe8fc64453b023 = function(arg0, arg1) {
        const ret = arg1.search;
        const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
        getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
    };
    imports.wbg.__wbg_send_171576d2f7487517 = function() { return handleError(function (arg0, arg1, arg2) {
        arg0.send(getStringFromWasm0(arg1, arg2));
    }, arguments) };
    imports.wbg.__wbg_send_3d2cf376613294f0 = function() { return handleError(function (arg0, arg1, arg2) {
        arg0.send(getArrayU8FromWasm0(arg1, arg2));
    }, arguments) };
    imports.wbg.__wbg_set_3f1d0b984ed272ed = function(arg0, arg1, arg2) {
        arg0[arg1] = arg2;
    };
    imports.wbg.__wbg_set_8b342d8cd9d2a02c = function() { return handleError(function (arg0, arg1, arg2, arg3, arg4) {
        arg0.set(getStringFromWasm0(arg1, arg2), getStringFromWasm0(arg3, arg4));
    }, arguments) };
    imports.wbg.__wbg_set_907fb406c34a251d = function(arg0, arg1, arg2) {
        const ret = arg0.set(arg1, arg2);
        return ret;
    };
    imports.wbg.__wbg_set_binaryType_9d839cea8fcdc5c3 = function(arg0, arg1) {
        arg0.binaryType = __wbindgen_enum_BinaryType[arg1];
    };
    imports.wbg.__wbg_set_body_3c365989753d61f4 = function(arg0, arg1) {
        arg0.body = arg1;
    };
    imports.wbg.__wbg_set_c213c871859d6500 = function(arg0, arg1, arg2) {
        arg0[arg1 >>> 0] = arg2;
    };
    imports.wbg.__wbg_set_c2abbebe8b9ebee1 = function() { return handleError(function (arg0, arg1, arg2) {
        const ret = Reflect.set(arg0, arg1, arg2);
        return ret;
    }, arguments) };
    imports.wbg.__wbg_set_code_ad2fcdb6f5e722f6 = function(arg0, arg1) {
        arg0.code = arg1;
    };
    imports.wbg.__wbg_set_headers_6926da238cd32ee4 = function(arg0, arg1) {
        arg0.headers = arg1;
    };
    imports.wbg.__wbg_set_method_c02d8cbbe204ac2d = function(arg0, arg1, arg2) {
        arg0.method = getStringFromWasm0(arg1, arg2);
    };
    imports.wbg.__wbg_set_once_6faa794a6bcd7d25 = function(arg0, arg1) {
        arg0.once = arg1 !== 0;
    };
    imports.wbg.__wbg_set_reason_25c61f7f2b074a32 = function(arg0, arg1, arg2) {
        arg0.reason = getStringFromWasm0(arg1, arg2);
    };
    imports.wbg.__wbg_set_search_3181eea18a6a72b8 = function(arg0, arg1, arg2) {
        arg0.search = getStringFromWasm0(arg1, arg2);
    };
    imports.wbg.__wbg_stack_0ed75d68575b0f3c = function(arg0, arg1) {
        const ret = arg1.stack;
        const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
        getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
    };
    imports.wbg.__wbg_static_accessor_GLOBAL_89e1d9ac6a1b250e = function() {
        const ret = typeof global === 'undefined' ? null : global;
        return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
    };
    imports.wbg.__wbg_static_accessor_GLOBAL_THIS_8b530f326a9e48ac = function() {
        const ret = typeof globalThis === 'undefined' ? null : globalThis;
        return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
    };
    imports.wbg.__wbg_static_accessor_SELF_6fdf4b64710cc91b = function() {
        const ret = typeof self === 'undefined' ? null : self;
        return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
    };
    imports.wbg.__wbg_static_accessor_WINDOW_b45bfc5a37f6cfa2 = function() {
        const ret = typeof window === 'undefined' ? null : window;
        return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
    };
    imports.wbg.__wbg_status_de7eed5a7a5bfd5d = function(arg0) {
        const ret = arg0.status;
        return ret;
    };
    imports.wbg.__wbg_subarray_480600f3d6a9f26c = function(arg0, arg1, arg2) {
        const ret = arg0.subarray(arg1 >>> 0, arg2 >>> 0);
        return ret;
    };
    imports.wbg.__wbg_text_dc33c15c17bdfb52 = function() { return handleError(function (arg0) {
        const ret = arg0.text();
        return ret;
    }, arguments) };
    imports.wbg.__wbg_then_4f46f6544e6b4a28 = function(arg0, arg1) {
        const ret = arg0.then(arg1);
        return ret;
    };
    imports.wbg.__wbg_then_70d05cf780a18d77 = function(arg0, arg1, arg2) {
        const ret = arg0.then(arg1, arg2);
        return ret;
    };
    imports.wbg.__wbg_toString_7da7c8dbec78fcb8 = function(arg0) {
        const ret = arg0.toString();
        return ret;
    };
    imports.wbg.__wbg_toString_8eec07f6f4c057e4 = function(arg0) {
        const ret = arg0.toString();
        return ret;
    };
    imports.wbg.__wbg_url_3e15bfb59fa6b660 = function(arg0, arg1) {
        const ret = arg1.url;
        const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
        getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
    };
    imports.wbg.__wbg_value_692627309814bb8c = function(arg0) {
        const ret = arg0.value;
        return ret;
    };
    imports.wbg.__wbg_versions_c01dfd4722a88165 = function(arg0) {
        const ret = arg0.versions;
        return ret;
    };
    imports.wbg.__wbg_warn_1d74dddbe2fd1dbb = function(arg0) {
        console.warn(arg0);
    };
    imports.wbg.__wbg_wasClean_3d7c0cf05bd0a123 = function(arg0) {
        const ret = arg0.wasClean;
        return ret;
    };
    imports.wbg.__wbindgen_cast_2241b6af4c4b2941 = function(arg0, arg1) {
        // Cast intrinsic for `Ref(String) -> Externref`.
        const ret = getStringFromWasm0(arg0, arg1);
        return ret;
    };
    imports.wbg.__wbindgen_cast_2bfc34beb99a7fdd = function(arg0, arg1) {
        // Cast intrinsic for `Closure(Closure { dtor_idx: 418, function: Function { arguments: [NamedExternref("CloseEvent")], shim_idx: 409, ret: Unit, inner_ret: Some(Unit) }, mutable: true }) -> Externref`.
        const ret = makeMutClosure(arg0, arg1, wasm.wasm_bindgen__closure__destroy__h1e85cdbd5ecc4669, wasm_bindgen__convert__closures_____invoke__h579a4fb2f5f72072);
        return ret;
    };
    imports.wbg.__wbindgen_cast_4625c577ab2ec9ee = function(arg0) {
        // Cast intrinsic for `U64 -> Externref`.
        const ret = BigInt.asUintN(64, arg0);
        return ret;
    };
    imports.wbg.__wbindgen_cast_81293da83642d946 = function(arg0, arg1) {
        // Cast intrinsic for `Closure(Closure { dtor_idx: 418, function: Function { arguments: [], shim_idx: 408, ret: Unit, inner_ret: Some(Unit) }, mutable: true }) -> Externref`.
        const ret = makeMutClosure(arg0, arg1, wasm.wasm_bindgen__closure__destroy__h1e85cdbd5ecc4669, wasm_bindgen__convert__closures_____invoke__h4ae627bff36e25e6);
        return ret;
    };
    imports.wbg.__wbindgen_cast_90c7ffddc798a274 = function(arg0, arg1) {
        // Cast intrinsic for `Closure(Closure { dtor_idx: 418, function: Function { arguments: [NamedExternref("MessageEvent")], shim_idx: 409, ret: Unit, inner_ret: Some(Unit) }, mutable: true }) -> Externref`.
        const ret = makeMutClosure(arg0, arg1, wasm.wasm_bindgen__closure__destroy__h1e85cdbd5ecc4669, wasm_bindgen__convert__closures_____invoke__h579a4fb2f5f72072);
        return ret;
    };
    imports.wbg.__wbindgen_cast_9ae0607507abb057 = function(arg0) {
        // Cast intrinsic for `I64 -> Externref`.
        const ret = arg0;
        return ret;
    };
    imports.wbg.__wbindgen_cast_cb9088102bce6b30 = function(arg0, arg1) {
        // Cast intrinsic for `Ref(Slice(U8)) -> NamedExternref("Uint8Array")`.
        const ret = getArrayU8FromWasm0(arg0, arg1);
        return ret;
    };
    imports.wbg.__wbindgen_cast_d6cd19b81560fd6e = function(arg0) {
        // Cast intrinsic for `F64 -> Externref`.
        const ret = arg0;
        return ret;
    };
    imports.wbg.__wbindgen_cast_d8e8284c84f48462 = function(arg0, arg1) {
        // Cast intrinsic for `Closure(Closure { dtor_idx: 418, function: Function { arguments: [NamedExternref("Event")], shim_idx: 409, ret: Unit, inner_ret: Some(Unit) }, mutable: true }) -> Externref`.
        const ret = makeMutClosure(arg0, arg1, wasm.wasm_bindgen__closure__destroy__h1e85cdbd5ecc4669, wasm_bindgen__convert__closures_____invoke__h579a4fb2f5f72072);
        return ret;
    };
    imports.wbg.__wbindgen_cast_e5a2dd494d38e065 = function(arg0, arg1) {
        // Cast intrinsic for `Closure(Closure { dtor_idx: 419, function: Function { arguments: [Externref], shim_idx: 430, ret: Unit, inner_ret: Some(Unit) }, mutable: true }) -> Externref`.
        const ret = makeMutClosure(arg0, arg1, wasm.wasm_bindgen__closure__destroy__h5b6f697e1db70ea0, wasm_bindgen__convert__closures_____invoke__hd4657407ae7052ff);
        return ret;
    };
    imports.wbg.__wbindgen_init_externref_table = function() {
        const table = wasm.__wbindgen_externrefs;
        const offset = table.grow(4);
        table.set(0, undefined);
        table.set(offset + 0, undefined);
        table.set(offset + 1, null);
        table.set(offset + 2, true);
        table.set(offset + 3, false);
        ;
    };

    return imports;
}

function __wbg_finalize_init(instance, module) {
    wasm = instance.exports;
    __wbg_init.__wbindgen_wasm_module = module;
    cachedDataViewMemory0 = null;
    cachedUint8ArrayMemory0 = null;


    wasm.__wbindgen_start();
    return wasm;
}

function initSync(module) {
    if (wasm !== undefined) return wasm;


    if (typeof module !== 'undefined') {
        if (Object.getPrototypeOf(module) === Object.prototype) {
            ({module} = module)
        } else {
            console.warn('using deprecated parameters for `initSync()`; pass a single object instead')
        }
    }

    const imports = __wbg_get_imports();

    if (!(module instanceof WebAssembly.Module)) {
        module = new WebAssembly.Module(module);
    }

    const instance = new WebAssembly.Instance(module, imports);

    return __wbg_finalize_init(instance, module);
}

async function __wbg_init(module_or_path) {
    if (wasm !== undefined) return wasm;


    if (typeof module_or_path !== 'undefined') {
        if (Object.getPrototypeOf(module_or_path) === Object.prototype) {
            ({module_or_path} = module_or_path)
        } else {
            console.warn('using deprecated parameters for the initialization function; pass a single object instead')
        }
    }

    if (typeof module_or_path === 'undefined') {
        module_or_path = new URL('switch_core_bg.wasm', import.meta.url);
    }
    const imports = __wbg_get_imports();

    if (typeof module_or_path === 'string' || (typeof Request === 'function' && module_or_path instanceof Request) || (typeof URL === 'function' && module_or_path instanceof URL)) {
        module_or_path = fetch(module_or_path);
    }

    const { instance, module } = await __wbg_load(await module_or_path, imports);

    return __wbg_finalize_init(instance, module);
}

export { initSync };
export default __wbg_init;
